window.initialLoadSidebar = false;
window.dataPasPage;
window.dataPost;
window.globalValue = {};
window.activePageData;
window.modalPageproperty;
window.ajaxSeoData = [];
window.slugID;
window.currentTab = 'page';
window.currentpage = 1;
window.currentpageType = 'onmenu';
window.currentpost = 1;
window.ActiveType = 0;
window.SiteConfigIframe = '';
(function ($) {
    var funcChangeNav = false;
    RVwys.isClickPageName = false;
    RVwys.plugin['Pageproperty'] = true;

    $(document).bind('editorReady', function () {
        //  Switch Content
        switchStepBarActive();

        var baseUrl = wex.url.baseUrl;
        var fb = $('#frameBody').get(0).contentWindow;
        parent.globalValue = JSON.parse(parent.globalSetting);
        parent.dataPasPage = parent.wex.page.page_tree;
        var currentPageData =
            typeof parent.currentPageJSON != 'undefined'
                ? parent.currentPageJSON
                : '';
        parent.dataPost = parent.wex.blog.blog_lists;

        RVwys.pageSetting.buttonOpenPageSetting = $('#wys-PageSetting');
        RVwys.pageSetting.buttonOpenDialogRenamePage = $('#renamePage');
        RVwys.pageSetting.buttonOpenDialogSetHomePage = $('#setHomePage');
        RVwys.pageSetting.buttonOpenDialogSetLinkToOtherSitePage = $(
            '#setLinkToOtherSitePage'
        );
        RVwys.pageSetting.buttonOpenDialogUnSetLinkToOtherSitePage = $(
            '#unSetLinkToOtherSitePage'
        );
        RVwys.pageSetting.buttonSaveRenamePage = $('#buttonSaveRenamePage');
        RVwys.pageSetting.buttonOpenDialogDeletePage = $('#deletePage');
        RVwys.pageSetting.buttonOpenAddPage = $('#wys-OpenAddPage');

        $('.iFrameSite').click(async function () {
            parent.$('.overlaypanel').remove();
            var overlaypanel = $('<div class="overlaypanel"></div>').css({
                opacity: '0.5',
                position: 'absolute',
                left: '0px',
                top: '0px',
                width: parent.$('body').width(),
                height: parent.$('body').height(),
                zIndex: '0',
            });

            var overlayTopBar = $('<div class="overlaypanel"></div>').css({
                opacity: '0.5',
                position: 'absolute',
                left: '0px',
                top: '0px',
                width: parent.$('#topbar').width(),
                height: parent.$('#topbar').height(),
                zIndex: '11',
            });

            parent.$('body').prepend(overlaypanel);
            parent.$('body').prepend(overlayTopBar);

            var result = await BuildIframePageProperties();

            if (result) {
                var type = currentPageData.slug_type.toLowerCase();
                var cmd = $(this).attr('cmd-active');
                var SlugId = currentPageData.slug_id;

                window.SiteConfigIframe.SetCurrentTab(type, SlugId, cmd);
            }
        });
    });

    RVwys.checkSlug = function (slug, returnVal) {
        $.ajax({
            type: 'POST',
            url: parent.wex.url.baseUrl + '/admin/wysiwyg/service/checkSlug',
            data: {
                slug: slug.trim(),
                _token: $('meta[name="csrf-token"]').attr('content'),
            },
            success: returnVal,
        });
    };

    RVwys.warningMaximun = function () {
        parent.$('.uk-modal-dialog #previewTitleSEO').keydown(function (event) {
            if ($(this).text().length > 255 && event.keyCode != 8) {
                event.preventDefault();
                parent.$('.uk-modal-dialog #warningMaximunTitleSEO').fadeIn();
                if ($(this).text().length > 256) {
                    $(this).text($(this).text().substring(0, 256));
                }
            } else {
                parent.$('.uk-modal-dialog #warningMaximunTitleSEO').fadeOut();
            }
        });

        parent.$('.uk-modal-dialog #previewDesSEO').keydown(function (event) {
            if ($(this).text().length > 155 && event.keyCode != 8) {
                event.preventDefault();
                parent
                    .$('.uk-modal-dialog #warningMaximunDescriptionSEO')
                    .fadeIn();
                if ($(this).text().length > 156) {
                    $(this).text($(this).text().substring(0, 156));
                }
            } else {
                parent
                    .$('.uk-modal-dialog #warningMaximunDescriptionSEO')
                    .fadeOut();
            }
        });
    };

    RVwys.designViewAddEvent('mousedown', function (e) {});

    RVwys.pageSetting = new PageSetting();

    RVwys.getAllAttr = function (elem) {
        var resultArr = [],
            resultObj = {};
        for (var i in elem.get(0).attributes) {
            if (elem.get(0).attributes[i].nodeName) {
                resultArr.push(
                    elem.get(0).attributes[i].nodeName +
                        '="' +
                        elem.get(0).attributes[i].value +
                        '"'
                );
                resultObj[elem.get(0).attributes[i].nodeName] = elem.get(
                    0
                ).attributes[i].value;
            }
        }
        return { resultArr: resultArr, resultObj: resultObj };
    };

    RVwys.pageSetting.arrPagename = new Array();
    RVwys.pageSetting.arrInternalPageName = new Array();

    function PageSetting() {
        this.deBugProperty = 'Debugger';
        this.AjaxUrl = function () {
            return RVS_AJAX_INDEX.replace('rvwysiwyguikit', 'sitebuilder');
        };

        this.handleEventPageSetting = function () {
            //open dialog page setting
            this.buttonOpenPageSetting.click(function (e) {
                e.stopPropagation();
                //clear arr pagename
                RVwys.pageSetting.arrPagename = [];

                var getPosition = $(this).position();
                if ($('#panelPageSetting').css('display') == 'none') {
                    //list page navigation
                    $('ul#listPage').empty();
                    RVwys.pageSetting.listPageNavigation();

                    $('#panelPageSetting').css({
                        left: '48%',
                        right: '50%',
                        top: getPosition.top + 40,
                    });
                    $('#panelPageSetting').show();
                    $('#panelPageSetting').data('opener', false);
                } else {
                    $('#panelPageSetting').hide();
                    $('.pageSetting').hide();
                    $('#panelPageSetting').data('opener', true);
                }
            });

            //off event
            jQuery('body').off('mouseover click', '.confListPage');
            jQuery('body').off('mouseover mouseout', '.editPageWithPageName');

            //open property page
            jQuery('body').on('click', '.confListPage', function (event) {
                //alert('confListPage')
                event.stopPropagation();

                $('.pageSetting').not('#panelPageSettingProperty').hide();

                $('#panelPageSettingProperty').data(
                    'pagename',
                    $(this).closest('li.liListPage').attr('data-pagename')
                );
                $('#panelPageSettingProperty').data(
                    'page_title',
                    $(this).closest('li.liListPage').attr('data-pagetitle')
                );
                $('#panelPageSettingProperty').data(
                    'page_keyword',
                    $(this).closest('li.liListPage').attr('data-pagekeyword')
                );
                $('#panelPageSettingProperty').data(
                    'page_description',
                    $(this)
                        .closest('li.liListPage')
                        .attr('data-pagedescription')
                );
                $('#panelPageSettingProperty').data(
                    'page_filename',
                    $(this).closest('li.liListPage').attr('data-pagefilename')
                );
                $('#panelPageSettingProperty').data(
                    'page_otherembed',
                    $(this).closest('li.liListPage').attr('data-otherembed')
                );
                $('#panelPageSettingProperty').data(
                    'page_css',
                    $(this).closest('li.liListPage').attr('data-pagecss')
                );

                var getPosition = $(this).offset();

                if ($('#panelPageSettingProperty').css('display') == 'none') {
                    $('#panelPageSettingProperty')
                        .css({
                            left: getPosition.left + 30,
                            top: getPosition.top + 30,
                        })
                        .show()
                        .data('pageid', $(this).attr('pageid'));
                } else {
                    if (
                        $(this).attr('pageid') ==
                        $('#panelPageSettingProperty').data('pageid')
                    ) {
                        $('#panelPageSettingProperty').hide();
                    } else {
                        $('#panelPageSettingProperty')
                            .hide()
                            .css({
                                left: getPosition.left + 30,
                                top: getPosition.top + 30,
                            })
                            .show()
                            .data('pageid', $(this).attr('pageid'));
                    }
                }

                //open SEO default
                $('#panelPageSettingProperty').find('#seoPage').show();
                $('#panelPageSettingProperty').find('#pageCss').show();
                $('#panelPageSettingProperty').find('#duplicatePage').show();

                //check home page
                if ($(this).attr('ishomepage') == 'true') {
                    $('#panelPageSettingProperty').data('ishomepage', true);
                    $('#panelPageSettingProperty').find('#setHomePage').hide();
                    $('#panelPageSettingProperty')
                        .find('#setLinkToOtherSitePage')
                        .hide();
                    $('#panelPageSettingProperty').find('#deletePage').hide();
                    $('#panelPageSettingProperty')
                        .find('#hideFromNavigation')
                        .hide();
                    $('#panelPageSettingProperty').find('#setHide').hide();
                } else {
                    $('#panelPageSettingProperty').data('ishomepage', false);
                    $('#panelPageSettingProperty').find('#setHomePage').show();
                    $('#panelPageSettingProperty').find('#setHide').show();
                    $('#panelPageSettingProperty')
                        .find('#hideFromNavigation')
                        .show();
                    $('#panelPageSettingProperty')
                        .find('#setLinkToOtherSitePage')
                        .show();
                    $('#panelPageSettingProperty').find('#deletePage').show();
                }

                //check set draft
                if ($(this).attr('issethide') == 'true') {
                    $('#panelPageSettingProperty').data('issethide', true);
                    $('#panelPageSettingProperty').find('#setHide').hide();
                    $('#panelPageSettingProperty').find('#unsetHide').show();
                } else {
                    $('#panelPageSettingProperty').data('issethide', false);
                    $('#panelPageSettingProperty').find('#setHide').show();
                    $('#panelPageSettingProperty').find('#unsetHide').hide();
                }

                //check internal page
                if ($(this).hasClass('internalPage')) {
                    $('#panelPageSettingProperty').find('#setHomePage').hide();
                    $('#panelPageSettingProperty').find('#setHide').hide();
                    $('#panelPageSettingProperty')
                        .find('#hideFromNavigation')
                        .hide();
                    $('#panelPageSettingProperty')
                        .find('#setLinkToOtherSitePage')
                        .hide();
                    $('#panelPageSettingProperty')
                        .find('#duplicatePage')
                        .hide();
                    $('#panelPageSettingProperty')
                        .find('#movetoNavigation')
                        .show();

                    $('#panelPageSettingProperty').data('isInternalPage', true);
                } else {
                    $('#panelPageSettingProperty')
                        .find('#movetoNavigation')
                        .hide();

                    $('#panelPageSettingProperty').data(
                        'isInternalPage',
                        false
                    );
                }

                //check main nav
                if ($(this).attr('ismainsub') == 'true') {
                    $('#panelPageSettingProperty').data('ismainsub', true);
                    $('#panelPageSettingProperty')
                        .find('#hideFromNavigation')
                        .hide();
                } else {
                    $('#panelPageSettingProperty').data('ismainsub', false);
                    if ($(this).hasClass('internalPage')) {
                        $('#panelPageSettingProperty')
                            .find('#hideFromNavigation')
                            .hide();
                    } else {
                        $('#panelPageSettingProperty')
                            .find('#hideFromNavigation')
                            .show();
                    }
                }

                //check current page
                var current_pagename = RVwys.frameBody
                    .find('ul.uk-breadcrumb')
                    .children()
                    .last()
                    .children()
                    .html();
                if (
                    current_pagename ==
                    $('#panelPageSettingProperty').data('pagename')
                ) {
                    $('#panelPageSettingProperty')
                        .find('#hideFromNavigation')
                        .hide();
                    $('#panelPageSettingProperty').find('#deletePage').hide();
                }

                //check link to other page
                var getLinkUrl = RVwys.frameBody
                    .find('span[pageid=' + $(this).attr('pageid') + ']')
                    .parent()
                    .attr('title');
                validateLinkUrl =
                    typeof getLinkUrl == 'string'
                        ? getLinkUrl.match(/(http\:\/\/)|(https\:\/\/)/gi)
                        : '';
                if (validateLinkUrl) {
                    console.log('++++ getLinkUrl:' + getLinkUrl);
                    $('#panelPageSettingProperty')
                        .find('.unSetLinkToOtherSitePage')
                        .show();
                    //external link hide

                    $('#panelPageSettingProperty').find('#setHomePage').hide();
                    $('#panelPageSettingProperty')
                        .find('#hideFromNavigation')
                        .hide();
                    $('#panelPageSettingProperty').find('#seoPage').hide();
                    $('#panelPageSettingProperty').find('#pageCss').hide();
                } else {
                    $('#panelPageSettingProperty')
                        .find('.unSetLinkToOtherSitePage')
                        .hide();
                }
            });

            //on hover page name change RVwys.isClickPageName = true for click edit page
            $('body').on('mouseover', '.editPageWithPageName', function () {
                RVwys.isClickPageName = true;
            });

            //on hover page name change RVwys.isClickPageName = false for click to rearrange page
            $('body').on('mouseout', '.editPageWithPageName', function () {
                RVwys.isClickPageName = false;
            });

            //off event
            jQuery('body').off('click', '.editPage');

            //edit page
            jQuery('body').on('click', '.editPage', function (event) {
                event.stopPropagation();
                RVwys.pageSetting.editPageFromPageSetting($(this));
            });
            jQuery('body').off('click', '.editPageWithPageName');
            //edit page
            jQuery('body').on(
                'click',
                '.editPageWithPageName',
                function (event) {
                    event.stopPropagation();
                    RVwys.pageSetting.editPageFromPageSetting($(this));
                }
            );

            RVwys.frameBody = $('#frameBody').contents();

            RVwys.pageSetting.ulListPageElem = $('ul#listPage');

            RVwys.pageSetting.ulLisInternaltPageElem = $('ul#listInternalPage');

            //add event rename page
            RVwys.pageSetting.renamePage.addEvent();

            //add event delete page
            RVwys.pageSetting.deletePage.addEvent();

            //add event set home page
            RVwys.pageSetting.setHomePage.addEvent();

            //add event add Link to Menu
            RVwys.pageSetting.addLinkToMenu.addEvent();

            //add event set draft
            RVwys.pageSetting.setHide.addEvent();

            //add event SEO Page
            RVwys.pageSetting.SEO.addEvent();

            //add event Css Page
            RVwys.pageSetting.CssPage.addEvent();

            //add event Internal Page
            RVwys.pageSetting.hideFromNavigation.addEvent();

            //add event Move to navigation
            RVwys.pageSetting.moveToNavigation.addEvent();

            //add event dubplicate page
            RVwys.pageSetting.duplicatePage.addEvent();

            //hide draft from nav menu
            RVwys.pageSetting.setHide.hideNavMenuIsDraft();

            //list internalpage setting
            RVwys.pageSetting.listInternalPageSetting(
                jsonInternalPageStructure
            );

            //set uk-active to current page:apiruk
            RVwys.pageSetting.setCurrentPage(parent.project_page_id);

            //click global setting will close pagesetting
            $('.groupOptions').click(function () {
                $('#panelPageSetting').hide();
                $('.pageSetting').hide();
                $('#panelPageSetting').data('opener', true);
            });

            $('ul#listPageProperty > li').click(function () {
                RVwys.warningUiKitDialog = false;
                $('.pagesettingwarning').hide();
            });

            // hide warning on add page
            $('input#pageName, #wys-OpenAddPage').click(function () {
                RVwys.warningUiKitDialog = false;
                $('#warningAddPageEmpty, #warningAddPageDuplicate').hide();
            });

            // rearrang page
            $('#sortablePage')
                .nestable({
                    containment: '.pagesetting-box-centent',
                    listNodeName: 'ul',
                    group: 1,
                    maxDepth: 3,
                })
                .on('change', function () {
                    //remove Overlay onDragable
                    if (
                        $('div#fBody')
                            .children()
                            .first()
                            .hasClass('overlaypanel')
                    ) {
                        $('div#fBody').children().first().remove();
                    }

                    var orderSortablePage = $('#sortablePage').nestable(
                            'serialize'
                        ),
                        pageOrderLv0 = 1,
                        arrPageList = [];

                    RVwys.frameBody.find('ul.uk-navbar-nav').empty();
                    RVwys.frameBody.find('ul.uk-nav-offcanvas').empty();

                    for (var i in orderSortablePage) {
                        var pageid = orderSortablePage[i].id,
                            ishomepage = orderSortablePage[i].ishomepage,
                            pagename = orderSortablePage[i].pagename,
                            sethide = orderSortablePage[i].sethide,
                            pagetarget = orderSortablePage[i].pagetarget;
                        pagetitle = orderSortablePage[i].title;
                        (hasChildren = orderSortablePage[i].hasOwnProperty(
                            'children'
                        )),
                            (page_keyword = orderSortablePage[i].pagekeyword),
                            (page_description =
                                orderSortablePage[i].pagedescription),
                            (page_title = orderSortablePage[i].pagetitle),
                            (page_filename = orderSortablePage[i].pagefilename),
                            (page_otherembed = orderSortablePage[i].otherembed);

                        if (pagetitle == 'undefined') {
                            pagetitle = '';
                        } else {
                            pagetitle = 'title="' + pagetitle + '"';
                        }

                        if (!page_title || page_title == '0') {
                            page_title = '';
                        }

                        var listNavHtml = `<li>
                                <a href="javascript:void(0)" target="${pagetarget}"  ${pagetitle} >
                                    <span pageid="${pageid}" is_homepage="${ishomepage}" is_draft="${sethide}"
                                    page_title="${page_title}" meta_keyword="${page_keyword}" meta_description="${page_description}"
                                    file_name="${page_filename}" other_embed="${page_otherembed}">${pagename}</span>
                                </a>
                            </li>`;
                        var listNavHtmlHasChildlevel0 =
                            '<li class="uk-parent" data-uk-dropdown="" aria-haspopup="true" aria-expanded="false">' +
                            '<a href="javascript:void(0)" target="' +
                            pagetarget +
                            '" ' +
                            pagetitle +
                            '>' +
                            '<span pageid="' +
                            pageid +
                            '" is_homepage="' +
                            ishomepage +
                            '" is_draft="' +
                            sethide +
                            '" page_title="' +
                            page_title +
                            '" meta_keyword="' +
                            page_keyword +
                            '" meta_description="' +
                            page_description +
                            '" file_name="' +
                            page_filename +
                            '" other_embed="' +
                            page_otherembed +
                            '">' +
                            pagename +
                            ' <i class="uk-icon-caret-down"></i></span></a>' +
                            '<div class="uk-dropdown uk-dropdown-navbar uk-dropdown-bottom" style="top: 40px; left: 0px;">' +
                            '<ul class="uk-nav uk-nav-navbar rv-text-left">' +
                            '</ul>' +
                            '</div></li>';
                        var listMobileNavHtmlHasChildlevel0 =
                            '<li class="uk-parent" aria-expanded="false">' +
                            '<a  href="#" target="_self" cmdhref="javascript:void(0)">' +
                            '<span pageid="' +
                            pageid +
                            '" is_homepage="' +
                            ishomepage +
                            '" is_draft="' +
                            sethide +
                            '" page_title="' +
                            page_title +
                            '" meta_keyword="' +
                            page_keyword +
                            '" meta_description="' +
                            page_description +
                            '" file_name="' +
                            page_filename +
                            '">' +
                            pagename +
                            '</span></a>' +
                            '<div style="overflow: hidden; position: relative; height: 0px;" class="uk-hidden">' +
                            '<ul class="uk-nav-sub level0">' +
                            '</ul>' +
                            '</div></li>';

                        if (hasChildren) {
                            var pageOrderLv1 = 1;
                            //nav desktop
                            RVwys.frameBody
                                .find('ul.uk-navbar-nav')
                                .append(listNavHtmlHasChildlevel0);
                            //nav mobile
                            RVwys.frameBody
                                .find('ul.uk-nav-offcanvas')
                                .append(listMobileNavHtmlHasChildlevel0);
                            arrPageList.push(pageid + ',0,' + pageOrderLv0);
                            console.log(pageOrderLv0);
                            pageOrderLv0++;

                            for (var j in orderSortablePage[i].children) {
                                console.log(orderSortablePage[i].children[j]);

                                var pagetitle =
                                    orderSortablePage[i].children[j].title;
                                var hasChildren = orderSortablePage[i].children[
                                    j
                                ].hasOwnProperty('children');
                                var page_title =
                                    orderSortablePage[i].children[j].pagetitle;
                                var page_filename =
                                    orderSortablePage[i].children[j].file_name;
                                var page_otherembed =
                                    orderSortablePage[i].children[j].otherembed;

                                if (pagetitle && pagetitle != 'undefined') {
                                    pagetitle = 'title="' + pagetitle + '"';
                                } else {
                                    pagetitle = '';
                                }

                                var listNavHtml =
                                    '<li>' +
                                    '<a href="javascript:void(0)" target="' +
                                    orderSortablePage[i].children[j]
                                        .pagetarget +
                                    '" ' +
                                    pagetitle +
                                    ' >' +
                                    '<span pageid="' +
                                    orderSortablePage[i].children[j].id +
                                    '" is_homepage="' +
                                    orderSortablePage[i].children[j]
                                        .ishomepage +
                                    '" is_draft="' +
                                    orderSortablePage[i].children[j].sethide +
                                    '" page_title="' +
                                    page_title +
                                    '" meta_keyword="' +
                                    orderSortablePage[i].children[j]
                                        .pagekeyword +
                                    '" meta_description="' +
                                    orderSortablePage[i].children[j]
                                        .pagedescription +
                                    '" file_name="' +
                                    orderSortablePage[i].children[j]
                                        .pagefilename +
                                    '" other_embed="' +
                                    page_otherembed +
                                    '">' +
                                    orderSortablePage[i].children[j].pagename +
                                    '</span></a>' +
                                    '</li>';
                                var listNavHtmlHasChildlevel1 =
                                    '<li>' +
                                    '<a href="javascript:void(0)" target="' +
                                    orderSortablePage[i].children[j]
                                        .pagetarget +
                                    '" ' +
                                    pagetitle +
                                    '>' +
                                    '<span pageid="' +
                                    orderSortablePage[i].children[j].id +
                                    '" is_homepage="' +
                                    orderSortablePage[i].children[j]
                                        .ishomepage +
                                    '" is_draft="' +
                                    orderSortablePage[i].children[j].sethide +
                                    '" page_title="' +
                                    page_title +
                                    '" meta_keyword="' +
                                    orderSortablePage[i].children[j]
                                        .pagekeyword +
                                    '" meta_description="' +
                                    orderSortablePage[i].children[j]
                                        .pagedescription +
                                    '" file_name="' +
                                    orderSortablePage[i].children[j]
                                        .pagefilename +
                                    '" other_embed="' +
                                    page_otherembed +
                                    '">' +
                                    orderSortablePage[i].children[j].pagename +
                                    ' </span>' +
                                    '<i class="uk-icon-caret-right"></i>' +
                                    '</a>' +
                                    '<ul class="uk-nav-sub">' +
                                    '</ul>' +
                                    '</li>';

                                var listMobileNavHtmlHasChildlevel1 =
                                    '<li>' +
                                    '<a href="javascript:void(0)" target="' +
                                    orderSortablePage[i].children[j]
                                        .pagetarget +
                                    '" ' +
                                    pagetitle +
                                    '>' +
                                    '<span pageid="' +
                                    orderSortablePage[i].children[j].id +
                                    '" is_homepage="' +
                                    orderSortablePage[i].children[j]
                                        .ishomepage +
                                    '" is_draft="' +
                                    orderSortablePage[i].children[j].sethide +
                                    '" page_title="' +
                                    page_title +
                                    '" meta_keyword="' +
                                    orderSortablePage[i].children[j]
                                        .pagekeyword +
                                    '" meta_description="' +
                                    orderSortablePage[i].children[j]
                                        .pagedescription +
                                    '" file_name="' +
                                    orderSortablePage[i].children[j]
                                        .pagefilename +
                                    '">' +
                                    orderSortablePage[i].children[j].pagename +
                                    ' </span>' +
                                    '</a>' +
                                    '<ul class="uk-nav-sub">' +
                                    '</ul>' +
                                    '</li>';
                                if (hasChildren) {
                                    var pageOrderLv2 = 1;

                                    //nav desktop
                                    RVwys.frameBody
                                        .find('ul.uk-navbar-nav')
                                        .children()
                                        .last()
                                        .find('ul.uk-nav-navbar')
                                        .append(listNavHtmlHasChildlevel1);
                                    //nav mobile
                                    RVwys.frameBody
                                        .find('ul.uk-nav-offcanvas')
                                        .children()
                                        .last()
                                        .find('ul.uk-nav-sub.level0')
                                        .append(
                                            listMobileNavHtmlHasChildlevel1
                                        );
                                    arrPageList.push(
                                        orderSortablePage[i].children[j].id +
                                            ',' +
                                            orderSortablePage[i].id +
                                            ',' +
                                            pageOrderLv1
                                    );
                                    pageOrderLv1++;

                                    for (var k in orderSortablePage[i].children[
                                        j
                                    ].children) {
                                        pagetitle =
                                            orderSortablePage[i].children[j]
                                                .children[k].title;
                                        hasChildren = orderSortablePage[
                                            i
                                        ].children[j].children[
                                            k
                                        ].hasOwnProperty('children');
                                        (page_title =
                                            orderSortablePage[i].children[j]
                                                .children[k].pagetitle),
                                            (page_otherembed =
                                                orderSortablePage[i].children[j]
                                                    .children[k].otherembed);

                                        if (
                                            pagetitle &&
                                            pagetitle != 'undefined'
                                        ) {
                                            pagetitle =
                                                'title="' + pagetitle + '"';
                                        } else {
                                            pagetitle = '';
                                        }

                                        if (!page_title || page_title == '0') {
                                            page_title = '';
                                        }

                                        var listNavHtml =
                                            '<li>' +
                                            '<a href="javascript:void(0)" target="' +
                                            orderSortablePage[i].children[j]
                                                .children[k].pagetarget +
                                            '" ' +
                                            pagetitle +
                                            ' >' +
                                            '<span pageid="' +
                                            orderSortablePage[i].children[j]
                                                .children[k].id +
                                            '" is_homepage="' +
                                            orderSortablePage[i].children[j]
                                                .children[k].ishomepage +
                                            '" is_draft="' +
                                            orderSortablePage[i].children[j]
                                                .children[k].sethide +
                                            '" page_title="' +
                                            page_title +
                                            '" meta_keyword="' +
                                            orderSortablePage[i].children[j]
                                                .children[k].pagekeyword +
                                            '" meta_description="' +
                                            orderSortablePage[i].children[j]
                                                .children[k].pagedescription +
                                            '" file_name="' +
                                            orderSortablePage[i].children[j]
                                                .children[k].pagefilename +
                                            '" other_embed="' +
                                            page_otherembed +
                                            '">' +
                                            orderSortablePage[i].children[j]
                                                .children[k].pagename +
                                            '</span></a>' +
                                            '</li>';

                                        //nav desktop
                                        RVwys.frameBody
                                            .find('ul.uk-navbar-nav')
                                            .children()
                                            .last()
                                            .find('ul.uk-nav-navbar')
                                            .children()
                                            .last()
                                            .find('ul.uk-nav-sub')
                                            .append(listNavHtml);
                                        //nav mobile
                                        RVwys.frameBody
                                            .find('ul.uk-nav-offcanvas')
                                            .children()
                                            .last()
                                            .find('ul.uk-nav-sub.level0')
                                            .children()
                                            .last()
                                            .find('ul.uk-nav-sub')
                                            .append(listNavHtml);

                                        arrPageList.push(
                                            orderSortablePage[i].children[j]
                                                .children[k].id +
                                                ',' +
                                                orderSortablePage[i].children[j]
                                                    .id +
                                                ',' +
                                                pageOrderLv2
                                        );
                                        pageOrderLv2++;
                                    }
                                } else {
                                    //nav desktop
                                    RVwys.frameBody
                                        .find('ul.uk-navbar-nav')
                                        .children()
                                        .last()
                                        .find('ul.uk-nav-navbar')
                                        .append(listNavHtml);
                                    //nav mobile
                                    RVwys.frameBody
                                        .find('ul.uk-nav-offcanvas')
                                        .children()
                                        .last()
                                        .find('ul.uk-nav-sub.level0')
                                        .append(listNavHtml);
                                    arrPageList.push(
                                        orderSortablePage[i].children[j].id +
                                            ',' +
                                            orderSortablePage[i].id +
                                            ',' +
                                            pageOrderLv1
                                    );
                                    pageOrderLv1++;
                                }
                            }
                        } else {
                            //nav desktop
                            RVwys.frameBody
                                .find('ul.uk-navbar-nav')
                                .append(listNavHtml);
                            //nav mobile
                            RVwys.frameBody
                                .find('ul.uk-nav-offcanvas')
                                .append(listNavHtml);

                            arrPageList.push(pageid + ',0,' + pageOrderLv0);
                            pageOrderLv0++;
                        }
                    }

                    console.log('funcChangeNav->' + funcChangeNav);
                    if (funcChangeNav) {
                        console.log('clearTimeout');
                        clearTimeout(funcChangeNav);
                    }
                    funcChangeNav = setTimeout(function () {
                        $.ajax({
                            type: 'POST',
                            url: RVwys.pageSetting.AjaxUrl(),
                            data: {
                                rvsMgr: 'PageContent',
                                rvsAct: 'savePageRearrange',
                                aData: arrPageList,
                            }, // serializes the form's elements.
                            success: function (data) {
                                $('body').css('cursor', 'default');
                                console.log(data);
                            },
                        });
                    }, 500);

                    //list page navigation
                    $('ul#listPage').empty();
                    RVwys.pageSetting.listPageNavigation();

                    console.log(arrPageList);
                    $('body').css('cursor', 'default');

                    RVwys.frameBody
                        .find('.uk-navbar-nav span[pageid]')
                        .off('click');
                    RVwys.frameBody
                        .find('.uk-navbar-nav span[pageid]')
                        .click(function () {
                            //RVwys.pageSetting.editPageFromPageSetting($(this));
                        });
                });

            //close page setting onclick body area
            RVwys.frameBody
                .contents()
                .find('body')
                .click(function () {
                    $('#panelPageSetting').hide();
                    $('.pageSetting').hide();
                    $('#panelPageSetting').data('opener', false);
                });

            //close page setting onclick body area
            $('.rvinner-wrapper')
                .children('.topbar')
                .click(function () {
                    $('#panelPageSetting').hide();
                    $('.pageSetting').hide();
                    $('#panelPageSetting').data('opener', false);
                });

            //cancel close pageSetting onclick page setting area
            $('#panelPageSettingProperty').click(function (event) {
                event.stopPropagation();
            });

            //cancel close pageSetting onclick page setting area
            $('body').on('click', '.uk-modal-dialog', function (event) {
                event.stopPropagation();
            });

            //on click navigation go to this page
            RVwys.frameBody
                .find('.uk-navbar-nav span[pageid]')
                .click(function () {
                    //RVwys.pageSetting.editPageFromPageSetting($(this));
                });
        };

        this.overLayPanalOnDragListPage = function () {
            var overlaypanel = $('<div class="overlaypanel"></div>').css({
                backgroundColor: 'red',
                opacity: '0.0',
                position: 'absolute',
                left: '0px',
                top: '0px',
                zIndex: '0',
                width: $('body').width(),
                height: $('body').height(),
            });
            if (!$('div#fBody').children().first().hasClass('overlaypanel')) {
                $('div#fBody').prepend(overlaypanel);
            }
        };

        //--------------------------------------------------------------------------------------------------------
        //get FooterData
        this.getFooterData = function (pageName, objPage) {
            var pageId = objPage.attr('pageid');
            var isDraft = objPage.attr('is_draft');

            console.log('getFooterData:pageId:' + pageId);

            if (isDraft != 'undefined' && isDraft == '1') {
                //case: isDraft ไม่ต้องแสดง
                console.log('case: isDraft:' + isDraft);
                return `<span pageid="${pageId}" is_draft="1" style="display: none;"> | <a href="javascript:void(0)" class="sitemapFooterLink" style="font-family: &quot;Open Sans&quot;, Arial, sans-serif;">
                    ${pageName}</a> </span>`;
            }
            return `<span pageid="${pageId}" is_draft="0"> | <a href="javascript:void(0)" class="sitemapFooterLink" style="font-family: &quot;Open Sans&quot;, Arial, sans-serif;">
                ${pageName}</a></span>`;
        };

        //build pageCss by pageId
        //use call RVwys.pageSetting.buildCssByPageId(pageId);
        this.buildCssByPageId = function (pageId, targetPageId, action) {
            console.log('buildCssByPageId: action: ' + action);
            console.log('buildCssByPageId: from pageId: ' + pageId);
            console.log('buildCssByPageId: target pageId: ' + targetPageId);

            //กรณีที่ไม่เคย set css มาเลยจะไม่สามารถ หา href customCssProject เพื่อ appen ต่อได้
            //ให้ build default
            var defaultCssPageUrl =
                parent.wex.url.baseUrl +
                '/customcss/cssProjectPage' +
                pageId +
                '.css?v=123456';

            //build pageCss
            var cssPageUrl = RVwys.frameBody
                .find('#customCssPage' + pageId)
                .attr('href');
            //console.log('0 cssPageUrl: ' + cssPageUrl);
            if (typeof cssPageUrl == 'undefined') {
                //ถ้าไม่มีให้ append defaultCssPageUrl
                cssPageUrl = defaultCssPageUrl;
                RVwys.frameBody
                    .find("link[href*='Navigator.css']")
                    .after(
                        '<link rel="stylesheet" type="text/css" id="customCssPage' +
                            pageId +
                            '" href="' +
                            cssPageUrl +
                            '">'
                    );
                console.log('append defaultCssPageUrl:');
            } else {
                console.log('Warning:: Cannot append css.');
            }

            console.log('typeof cssPageUrl: ' + typeof cssPageUrl);
            //console.log('1 cssPageUrl: ' + cssPageUrl);
            if (typeof cssPageUrl != 'undefined' && cssPageUrl != 'undefined') {
                console.log('update css file');
                (dateObj = new Date()), (dateValue = dateObj.valueOf());
                if (pageId != targetPageId) {
                    //case: switch pageId to other page
                    //และ replace pageId เป็นหน้าที่เปลี่ยนไป
                    console.log('switch cssProjectPage');
                    var fromCssPageId = 'cssProjectPage' + pageId;
                    var strCssPageId = new RegExp(fromCssPageId, 'g');
                    cssPageUrl = cssPageUrl.replace(
                        strCssPageId,
                        'cssProjectPage' + targetPageId
                    );
                }

                cssPageUrl = cssPageUrl.replace(/(v=)(.*)/g, '$1' + dateValue);
                console.log('target: ' + cssPageUrl);
                //ลบ href customCssPage ออก
                RVwys.frameBody.find('#customCssPage' + pageId).remove();

                var haveCustomCssProject = RVwys.frameBody
                    .find('#customCssProject')
                    .attr('href');
                var haveCustomCssPage = RVwys.frameBody
                    .find('#customCssPage' + targetPageId)
                    .attr('href');
                if (typeof haveCustomCssProject != 'undefined') {
                    //if selector cssGlobal ได้ ให้เพิ่มเข้าไปหลัง customCssProject
                    console.log('append after: #customCssProject');
                    RVwys.frameBody
                        .find('#customCssProject')
                        .after(
                            '<link rel="stylesheet" type="text/css" id="customCssPage' +
                                targetPageId +
                                '" href="' +
                                cssPageUrl +
                                '">'
                        );
                } else if (typeof haveCustomCssPage == 'undefined') {
                    //if selector cssGlobal ไม่ได้ ให้เพิ่มเข้าไปหลัง href Navigator.css
                    console.log('append after: Navigator.css');
                    RVwys.frameBody
                        .find("link[href*='Navigator.css']")
                        .after(
                            '<link rel="stylesheet" type="text/css" id="customCssPage' +
                                targetPageId +
                                '" href="' +
                                cssPageUrl +
                                '">'
                        );
                } else {
                    console.log('append css success:');
                }
            } //end typeof cssPageUrl
        };

        this.listPageNavigation = function () {
            console.log('plugins/PageSetting listPageNavigation()');
            var footerData = '';
            //list page navigation
            //alert(RVwys.frameBody.find('nav.uk-navbar >div#rvnav-center> ul.uk-navbar-nav > li > a > span').size())
            //alert(RVwys.frameBody.find('nav span[is_homepage]').size())

            RVwys.frameBody
                .find('.uk-navbar-nav')
                .first()
                .find('span[is_homepage]:not(.uk-nav-navbar span[is_homepage])')
                .each(function () {
                    if ($(this).closest('li').hasClass('uk-parent')) {
                        console.log(
                            'haveSub page_name: ' + $(this).text() + ' +'
                        );
                        //console.log($(this));

                        footerData =
                            footerData +
                            RVwys.pageSetting.getFooterData(
                                $(this).text() + ' +',
                                $(this)
                            );
                        RVwys.pageSetting.listPageSettingHasSubMenu(
                            $(this),
                            RVwys.pageSetting.ulListPageElem,
                            'lv0hassubpage'
                        );

                        //list page navigation sub level1
                        $(this)
                            .closest('li')
                            .find('ul.uk-nav > li > a > span')
                            .each(function () {
                                if (
                                    $(this)
                                        .closest('li')
                                        .children('ul')
                                        .hasClass('uk-nav-sub')
                                ) {
                                    RVwys.pageSetting.listPageSettingHasSubMenu(
                                        $(this),
                                        RVwys.pageSetting.ulListPageElem,
                                        'lv1hassubpage'
                                    );

                                    //list page navigation sub level2
                                    $(this)
                                        .closest('li')
                                        .find('ul.uk-nav-sub > li > a > span')
                                        .each(function () {
                                            RVwys.pageSetting.listPageSettingNotSubMenu(
                                                $(this),
                                                RVwys.pageSetting
                                                    .ulListPageElem,
                                                'lv2nosubpage'
                                            );
                                        });
                                } else {
                                    RVwys.pageSetting.listPageSettingNotSubMenu(
                                        $(this),
                                        RVwys.pageSetting.ulListPageElem,
                                        'lv1nosubpage'
                                    );
                                }
                            });
                    } else {
                        console.log('noSub page_name: ' + $(this).text());
                        //console.log($(this));
                        footerData =
                            footerData +
                            RVwys.pageSetting.getFooterData(
                                $(this).text(),
                                $(this)
                            );
                        RVwys.pageSetting.listPageSettingNotSubMenu(
                            $(this),
                            RVwys.pageSetting.ulListPageElem,
                            'lv0nosubpage'
                        );
                    }
                });

            console.log('plugins/PageSetting update sitemapFooter');
            //update footer
            $('#frameBody').contents().find('#sitemapFooter').html(footerData);
            return true;
        };

        //list page to page setting(has sub menu)
        this.listPageSettingHasSubMenu = function (
            navAttr,
            UlListPage,
            pageLayer
        ) {
            console.log('listPageSettingHasSubMenu() ');
            var PageName = navAttr.clone().children().remove().end().html(),
                titlePageName = PageName.length > 10 ? PageName : '',
                PageTarget = navAttr.parent().attr('target'),
                Link = navAttr.parent().attr('title'),
                PageId = navAttr.attr('pageid'),
                IsHomePage = navAttr.attr('is_homepage'),
                Isdraft = navAttr.attr('is_draft'),
                page_Title = navAttr.attr('page_title'),
                pageMeta_Keyword = navAttr.attr('meta_keyword'),
                pageMeta_Description = navAttr.attr('meta_description'),
                subLeve =
                    pageLayer == 'lv0hassubpage' ? 'mainlev1' : 'mainlev2',
                colorFontDraft = Isdraft == '1' ? 'color:#ccc;' : '',
                checkIsDraft =
                    Isdraft == '1'
                        ? '<span pageid="' +
                          PageId +
                          '" class="textdraft" style="display:inline;"> (Draft) </span>'
                        : '',
                checkLinkToOtherPage = RVwys.frameBody
                    .find('span[pageid=' + PageId + ']')
                    .parent()
                    .attr('title'),
                fileName = navAttr.attr('file_name'),
                other_embed = navAttr.attr('other_embed'),
                page_css = navAttr.attr('page_css');

            if (checkLinkToOtherPage) {
                console.log(
                    '>>>> PageName: ' +
                        PageName +
                        ' checkLinkToOtherPage: ' +
                        checkLinkToOtherPage
                );
                checkLinkToOtherPage = 'uk-icon-link';
            } else {
                checkLinkToOtherPage = 'icon-edit';
            }

            var hassubpageHTML =
                '<li class="liListPage dd-item"  data-id="' +
                PageId +
                '" data-pagename="' +
                PageName +
                '" data-ishomepage="' +
                IsHomePage +
                '" data-sethide="' +
                Isdraft +
                '" data-pagetarget="' +
                PageTarget +
                '" data-title="' +
                Link +
                '" data-pagetitle="' +
                page_Title +
                '" data-pagekeyword="' +
                pageMeta_Keyword +
                '" data-pagedescription="' +
                pageMeta_Description +
                '" data-pagefilename="' +
                fileName +
                '" data-otherembed="' +
                other_embed +
                '" data-pagecss="' +
                page_css +
                '">' +
                '<button data-action="collapse" type="button">Collapse</button>' +
                '<button data-action="expand" type="button" style="display: none;">Expand</button>' +
                '<div class="editpagename dd-handle" pageid="' +
                PageId +
                '" style="' +
                colorFontDraft +
                '"><span class="editPageWithPageName" pageid="' +
                PageId +
                '" pagename="' +
                PageName +
                '" title="' +
                titlePageName +
                '">' +
                checkIsDraft +
                PageName +
                ' </span></div>' +
                '<span class="icon-control">' +
                '<i class="' +
                checkLinkToOtherPage +
                ' uk-icon-small editPage" title="Edit Page" pageid="' +
                PageId +
                '"></i>' +
                '<i class="icon-pagesetting uk-icon-small confListPage" pageid="' +
                PageId +
                '" pagename="' +
                PageName +
                '" ismainsub="true"></i>' +
                '</span>' +
                '<ul class="dd-list ' +
                subLeve +
                '"></ul>' +
                '</li>';

            switch (pageLayer) {
                case 'lv0hassubpage':
                    UlListPage.append(hassubpageHTML);
                    break;
                case 'lv1hassubpage':
                    UlListPage.children()
                        .last()
                        .children('.dd-list')
                        .append(hassubpageHTML);
                    break;
            }

            if (IsHomePage == '1') {
                console.log('HomepageName :: ' + PageName);
                //UlListPage.find('i[pageid='+PageId+']').attr('ishomepage', 'true').closest('li.liListPage').prepend('<i class="uk-icon-home"></i>');
                UlListPage.find('i[pageid=' + PageId + ']').attr(
                    'ishomepage',
                    'true'
                );
                $('div[pageid=' + PageId + ']')
                    .closest('li.liListPage')
                    .prepend(
                        '<i class="uk-icon-small icon-home icon-control-home"></i>'
                    );
            }
            if (Isdraft == '1') {
                UlListPage.find('i[pageid=' + PageId + ']').attr(
                    'issethide',
                    'true'
                );
                RVwys.frameBody
                    .find('span[pageid=' + PageId + ']')
                    .closest('li')
                    .hide();
            }

            RVwys.pageSetting.arrPagename.push(PageName);

            return true;
        };

        //list page to page setting(not sub menu)
        this.listPageSettingNotSubMenu = function (
            navAttr,
            UlListPage,
            pageLayer
        ) {
            console.log('listPageSettingNotSubMenu() ');
            var PageName = navAttr.clone().children().remove().end().html(),
                titlePageName = PageName.length > 10 ? PageName : '',
                PageTarget = navAttr.parent().attr('target'),
                Link = navAttr.parent().attr('title'),
                PageId = navAttr.attr('pageid'),
                IsHomePage = navAttr.attr('is_homepage'),
                Isdraft = navAttr.attr('is_draft'),
                page_Title = navAttr.attr('page_title'),
                pageMeta_Keyword = navAttr.attr('meta_keyword'),
                pageMeta_Description = navAttr.attr('meta_description'),
                colorFontDraft = Isdraft == '1' ? 'color:#ccc;' : '',
                checkIsDraft =
                    Isdraft == '1'
                        ? '<span pageid="' +
                          PageId +
                          '" class="textdraft" style="display:inline;"> (Draft) </span>'
                        : '',
                checkLinkToOtherPage = RVwys.frameBody
                    .find('span[pageid=' + PageId + ']')
                    .parent()
                    .attr('title'),
                fileName = navAttr.attr('file_name'),
                other_embed = navAttr.attr('other_embed'),
                page_css = navAttr.attr('page_css');

            if (
                typeof checkLinkToOtherPage != 'undefined' &&
                checkLinkToOtherPage != 'undefined'
            ) {
                //console.log('***** typeof: ' + typeof checkLinkToOtherPage);
                //console.log('***** PageName: ' + PageName + ' Link: ' + Link);
                console.log(
                    '***** PageName: ' +
                        PageName +
                        ' checkLinkToOtherPage: ' +
                        checkLinkToOtherPage
                );
                checkLinkToOtherPage = 'uk-icon-link';
            } else {
                checkLinkToOtherPage = 'icon-edit';
            }
            PageNameEntites = htmlentities.encode(PageName);
            console.log('other_embed : ' + other_embed);

            var nosubpageHTML =
                '<li class="liListPage dd-item" data-id="' +
                PageId +
                '" data-pagename="' +
                PageName +
                '" data-ishomepage="' +
                IsHomePage +
                '" data-sethide="' +
                Isdraft +
                '" data-pagetarget="' +
                PageTarget +
                '" data-title="' +
                Link +
                '" data-pagetitle="' +
                page_Title +
                '" data-pagekeyword="' +
                pageMeta_Keyword +
                '" data-pagedescription="' +
                pageMeta_Description +
                '" data-pagefilename="' +
                fileName +
                '" data-otherembed="' +
                other_embed +
                '" data-pagecss="' +
                page_css +
                '">' +
                '<div class="editpagename dd-handle" pageid="' +
                PageId +
                '" style="' +
                colorFontDraft +
                '"><span class="editPageWithPageName" pageid="' +
                PageId +
                '" pagename="' +
                PageName +
                '" title="' +
                titlePageName +
                '"> ' +
                checkIsDraft +
                PageName +
                '</span></div>' +
                '<span class="icon-control">' +
                '<i class="' +
                checkLinkToOtherPage +
                ' uk-icon-small editPage" title="Edit Page" pageid="' +
                PageId +
                '"></i>' +
                '<i class="icon-pagesetting uk-icon-small confListPage" pageid="' +
                PageId +
                '" pagename="' +
                PageName +
                '"></i>' +
                '</span>' +
                '</li>';

            switch (pageLayer) {
                case 'lv0nosubpage':
                    UlListPage.append(nosubpageHTML);
                    break;
                case 'lv1nosubpage':
                    UlListPage.children()
                        .last()
                        .children('.dd-list')
                        .append(nosubpageHTML);
                    break;
                case 'lv2nosubpage':
                    UlListPage.children()
                        .last()
                        .children('.dd-list')
                        .children()
                        .last()
                        .children('.dd-list')
                        .append(nosubpageHTML);
                    break;
            }

            if (IsHomePage == '1') {
                //UlListPage.find('i[pageid='+PageId+']').attr('ishomepage', 'true').closest('li.liListPage').prepend('<i class="uk-icon-home"></i>');
                UlListPage.find('i[pageid=' + PageId + ']').attr(
                    'ishomepage',
                    'true'
                );
                $('div[pageid=' + PageId + ']')
                    .closest('li.liListPage')
                    .prepend(
                        '<i class="uk-icon-small icon-home icon-control-home"></i>'
                    );
            }
            if (Isdraft == '1') {
                UlListPage.find('i[pageid=' + PageId + ']').attr(
                    'issethide',
                    'true'
                );
                RVwys.frameBody
                    .find('span[pageid=' + PageId + ']')
                    .closest('li')
                    .hide();
            }

            RVwys.pageSetting.arrPagename.push(PageName);

            return true;
        };

        this.listInternalPageSetting = function (listInternalPageArr) {
            console.log(
                'fn: RVwys.pageSetting.listInternalPageSetting() plugins/PageSeting'
            );

            //clear internalpage list
            RVwys.pageSetting.ulLisInternaltPageElem.empty();

            if (listInternalPageArr.length == '0') {
                $('div.hideFromNav').hide();
                return false;
            }
            $('div.hideFromNav').show();

            $('div.hideFromNav').show();

            for (var indexArr in listInternalPageArr) {
                console.log(listInternalPageArr[indexArr]);
                var fileName = listInternalPageArr[indexArr].custom_page_name;
                if (fileName == '') {
                    //ถ้าไม่มี file name ให้ใช้ชื่อ page_name แทน
                    fileName = listInternalPageArr[indexArr].page_name;
                }

                fileName = fileName + '.html';

                var internalpageHTML =
                    '<li class="liListPage dd-item" data-id="' +
                    listInternalPageArr[indexArr].project_page_id +
                    '" data-pagename="' +
                    listInternalPageArr[indexArr].page_name +
                    '" data-pagefilename="' +
                    fileName +
                    '" data-ishomepage="0" data-sethide="' +
                    listInternalPageArr[indexArr].set_draft +
                    '" data-pagetarget="' +
                    listInternalPageArr[indexArr].target +
                    '" data-title="' +
                    listInternalPageArr[indexArr].external_url +
                    '" data-pagetitle="' +
                    listInternalPageArr[indexArr].page_title +
                    '" data-pagekeyword="' +
                    listInternalPageArr[indexArr].meta_keyword +
                    '" data-pagedescription="' +
                    listInternalPageArr[indexArr].meta_description +
                    '">' +
                    '<div class="editpagename dd-handle clear-cursormove" pageid="' +
                    listInternalPageArr[indexArr].project_page_id +
                    '"><span class="editPageWithPageName" pageid="' +
                    listInternalPageArr[indexArr].project_page_id +
                    '" pagename="' +
                    listInternalPageArr[indexArr].page_name +
                    '">' +
                    listInternalPageArr[indexArr].page_name +
                    '</span></div>' +
                    '<span class="icon-control">' +
                    '<i class="icon-edit uk-icon-small editPage" title="Edit Page" pageid="' +
                    listInternalPageArr[indexArr].project_page_id +
                    '"></i>' +
                    '<i class="icon-pagesetting uk-icon-small confListPage internalPage" pageid="' +
                    listInternalPageArr[indexArr].project_page_id +
                    '" pagename="' +
                    listInternalPageArr[indexArr].page_name +
                    '"></i>' +
                    '</span>' +
                    '</li>';
                RVwys.pageSetting.ulLisInternaltPageElem.append(
                    internalpageHTML
                );

                RVwys.pageSetting.arrInternalPageName.push(
                    listInternalPageArr[indexArr].page_name
                );
            }

            //console.log(jsonInternalPageStructure);
        };

        //set uk-active to current page
        this.setCurrentPage = function (pageId) {
            console.log(
                'fn: RVwys.pageSetting.setCurrentPage() plugins/PageSettin'
            );
            console.log('pageId: ' + pageId);
            //clear uk-active
            RVwys.frameBody
                .find('.uk-navbar-nav')
                .find('.uk-active')
                .removeClass('uk-active');

            var pageObj = RVwys.frameBody.find('span[pageid=' + pageId + ']');
            //lv0
            pageObj.parent().closest('li').addClass('uk-active');
            //parent have lv1
            pageObj
                .parent()
                .closest('li')
                .parent()
                .closest('li')
                .addClass('uk-active');
            //parent have lv2
            pageObj
                .parent()
                .closest('li')
                .parent()
                .closest('li')
                .parent()
                .closest('li')
                .addClass('uk-active');
        };

        this.editPageFromPageSetting = function (thisElem, isFromNav) {
            //set panelPageSettingProperty data pageid = this page id
            $('#panelPageSettingProperty').data(
                'pageid',
                thisElem.attr('pageid')
            );
            //check this nav is link to other page
            var getLinkUrl = RVwys.frameBody
                    .find('span[pageid=' + thisElem.attr('pageid') + ']')
                    .parent()
                    .attr('title'),
                getPageName = RVwys.frameBody
                    .find('span[pageid=' + thisElem.attr('pageid') + ']')
                    .html();

            //call setCurrentPage(pageId)
            RVwys.pageSetting.setCurrentPage(thisElem.attr('pageid'));

            if (getLinkUrl) {
                var getLinkUrlForCheck = getLinkUrl.split('/');
                getLinkUrlForCheck =
                    getLinkUrlForCheck[getLinkUrlForCheck.length - 1];
                getLinkUrlForCheck = getLinkUrlForCheck.replace('.html', '');
            }

            console.log(
                'editPageFromPageSetting page_id: ' + thisElem.attr('pageid')
            );
            console.log(
                'type of getLinkUrl: ' +
                    typeof getLinkUrl +
                    ' getLinkUrl: ' +
                    getLinkUrl
            );

            if (
                getLinkUrl != '' &&
                getLinkUrl != 'undefined' &&
                getLinkUrl != undefined &&
                getLinkUrlForCheck != getPageName
            ) {
                RVwys.uikitDialog(
                    'Link to other page',
                    $('#panelLinkToOtherPage').html(),
                    'OK',
                    function () {
                        var validateLinkUrl = $('.txtLinkOtherPage')
                            .eq(1)
                            .val()
                            .trim();
                        console.log('validateLinkUrl : ', validateLinkUrl);

                        validateLinkUrl = validateLinkUrl.match(
                            /(http\:\/\/)|(https\:\/\/)/gi
                        );

                        if ($('.txtLinkOtherPage').eq(1).val() == '') {
                            RVwys.pageSetting.addLinkToMenu.saveLinkToMenuAjax(
                                $('#panelPageSettingProperty').data('pageid'),
                                $('.txtLinkOtherPage').eq(1).val()
                            );
                            $('.txtLinkOtherPage')
                                .eq(1)
                                .nextAll('#warningLinkNoHttp')
                                .hide();
                            RVwys.warningUiKitDialog = false;
                        } else if (validateLinkUrl) {
                            RVwys.pageSetting.addLinkToMenu.saveLinkToMenuAjax(
                                $('#panelPageSettingProperty').data('pageid'),
                                $('.txtLinkOtherPage').eq(1).val()
                            );
                            $('.txtLinkOtherPage')
                                .eq(1)
                                .nextAll('#warningLinkNoHttp')
                                .hide();
                            RVwys.warningUiKitDialog = false;
                        } else {
                            $('.txtLinkOtherPage')
                                .eq(1)
                                .nextAll('#warningLinkNoHttp')
                                .show();
                            RVwys.warningUiKitDialog = true;
                        }
                    },
                    function () {
                        RVwys.warningUiKitDialog = false;
                    }
                );

                setTimeout(function () {
                    $('.txtLinkOtherPage').eq(1).val(getLinkUrl);
                    $('.txtLinkOtherPage')
                        .eq(1)
                        .nextAll('#warningLinkNoHttp')
                        .hide();
                }, 100);

                return false;
            }

            $('#panelPageSetting, #panelPageSettingProperty').hide();
            console.log(
                'current page_id: ' +
                    project_page_id +
                    ' save page_id: ' +
                    thisElem.attr('pageid')
            );
            $('#wys-save_page').trigger('click');

            //var watingLoadPage = UIkit.modal.blockUI("<div class='uk-modal-spinner'></div>"),
            var iframUrl =
                    SGL_JS_INDEX +
                    '/sitebuilder/rvwysiwyguikit/action/buildwys/project_page_id/' +
                    thisElem.attr('pageid'),
                getTitlePage =
                    thisElem.next().attr('pagename') ||
                    thisElem.attr('pagename') ||
                    thisElem.clone().children().remove().end().text();

            //set new title page
            thisElem.closest('html').find('title').html(getTitlePage);
            parent.document.title = getTitlePage;
            if (!$('div.holderEditPageHtml').hasClass('holderEditPageHtml')) {
                $('body').append(
                    "<div class='holderEditPageHtml' style='dispaly:none;'></div>"
                );
            }

            //build pageCss
            //case switch page to edit จะส่ง pageId เดิมและ pageId ที่จะ edit ไปคนละ id กัน
            console.log(
                'build pageCss:: Case switch current page:' +
                    project_page_id +
                    ' to page: ' +
                    thisElem.attr('pageid')
            );
            RVwys.pageSetting.buildCssByPageId(
                project_page_id,
                thisElem.attr('pageid'),
                'switchPage'
            );

            $('div.holderEditPageHtml').load(
                iframUrl + ' .bodyTemplate',
                function (response, status, xhr) {
                    if (status == 'success') {
                        RVwys.frameBody
                            .find('#selected_body')
                            .html(
                                $('div.holderEditPageHtml')
                                    .find('#selected_body')
                                    .html()
                            );
                        RVwys.frameBody
                            .find('#selected_pathway')
                            .html(
                                $('div.holderEditPageHtml')
                                    .find('#selected_pathway')
                                    .html()
                            );
                        document
                            .getElementById('frameBody')
                            .contentWindow.buildePathway();
                        $('div.holderEditPageHtml').remove();

                        project_page_id = thisElem.attr('pageid');
                        parent.project_page_id = thisElem.attr('pageid');

                        console.log(
                            'set project_page_id to ' + thisElem.attr('pageid')
                        );
                        console.log(
                            'set parent.project_page_id to ' +
                                thisElem.attr('pageid')
                        );

                        setTimeout(function () {
                            //$('#frameBody').get(0).contentWindow.testsortable();
                            //if($('#frameBody').get(0).contentWindow.$('#blockSubEditableSetting').html().length == '2'){
                            //$('#frameBody').get(0).contentWindow.$('#blockSubEditableSetting').html(blockSubEditableSetting_html);
                            //}
                            //$('#frameBody').get(0).contentWindow.$('.navMenu-blockSubEditableSetting').unwrap();
                            /*
						$('#frameBody').get(0).contentWindow.$('.RVWYSIWYGAREA').each(function(){
	        				$('#frameBody').get(0).contentWindow.RVwys.EditorByClass("#"+$(this).attr("id"), 'notfocus');
	        			});
						*/
                            $('#frameBody')
                                .get(0)
                                .contentWindow.RVwys.EditorByClass(
                                    '.RVWYSIWYGAREA'
                                );

                            $('#frameBody')
                                .get(0)
                                .contentWindow.RVwys.uikit.Tools('show');
                            $('#frameBody')
                                .get(0)
                                .contentWindow.RVwys.EditorByUIkit('EditPage');

                            var i = 0;

                            setTimeout(function () {
                                //watingLoadPage.hide();
                                //watingLoadPage = "";
                            }, 1000);
                        }, 500);
                    } else if (status == 'error') {
                    }
                }
            );

            //project_page_id = thisElem.attr("pageid");
            //parent.project_page_id = thisElem.attr("pageid");
        };
    }

    //deletePage
    RVwys.pageSetting.deletePage = function () {
        return {
            addEvent: function () {
                //event open dialog add page
                RVwys.pageSetting.buttonOpenAddPage.click(function (event) {
                    event.stopPropagation();

                    $('.pageSetting').not('#panelAddPage').hide();
                    $('#warningAddPageEmpty').hide();
                    var getPosition = $(this).offset();

                    if ($('#panelAddPage').css('display') == 'none') {
                        $('#panelAddPage')
                            .css({
                                left: getPosition.left + 15,
                                top: getPosition.top + 15,
                            })
                            .show();
                    } else {
                        $('#panelAddPage').hide();
                    }
                });

                //event open confirm dialog delete page
                RVwys.pageSetting.buttonOpenDialogDeletePage.click(function () {
                    $('.pageSetting').not('#panelPageSettingProperty').hide();

                    if ($('#panelPageSettingProperty').data('ismainsub')) {
                        UIkit.notify({
                            message: "It's main page",
                            status: 'warning',
                            timeout: 2000,
                            pos: 'top-center',
                        });
                    } else if (
                        $('#panelPageSettingProperty').data('ishomepage')
                    ) {
                        UIkit.notify({
                            message: "It's home page",
                            status: 'warning',
                            timeout: 2000,
                            pos: 'top-center',
                        });
                    } else {
                        RVwys.uikitDialog(
                            'Delete page',
                            'Delete page ' +
                                $('#panelPageSettingProperty').data('pagename'),
                            'Delete',
                            function () {
                                RVwys.pageSetting.deletePage.saveDeletePageAjax(
                                    $('#panelPageSettingProperty').data(
                                        'pageid'
                                    )
                                );
                            }
                        );
                    }
                });
            },
            saveDeletePageAjax: function (pageId) {
                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'PageContent',
                        rvsAct: 'delete',
                        project_page_id: pageId,
                    }, // serializes the form's elements.
                    success: function (data) {
                        //console.log('saveDeletePageAjax()');
                        //console.log(data);
                        //console.log(jsonInternalPageStructure);
                    },
                });

                var navMenuDeleteElem = RVwys.frameBody
                    .find('nav.uk-navbar')
                    .find('span[pageid=' + pageId + ']')
                    .closest('li');

                //remove attr issubmenu nav parent if child  = 0
                if (
                    navMenuDeleteElem.parent('ul').hasClass('uk-nav-sub') &&
                    navMenuDeleteElem.parent('ul').children('li').length == 1
                ) {
                    RVwys.pageSetting.deletePage.deleteNavCurrent(
                        navMenuDeleteElem
                            .parent('ul')
                            .parent('li')
                            .children()
                            .first()
                            .find('span')
                            .attr('pageid'),
                        navMenuDeleteElem.parent('ul')
                    );
                } else if (
                    navMenuDeleteElem.parent('ul').hasClass('uk-nav-navbar') &&
                    navMenuDeleteElem.parent('ul').children('li').length == 1
                ) {
                    RVwys.pageSetting.deletePage.deleteNavCurrent(
                        navMenuDeleteElem
                            .parent('ul')
                            .closest('li.uk-parent')
                            .children()
                            .first()
                            .find('span')
                            .attr('pageid'),
                        navMenuDeleteElem.parent('ul').parent('div'),
                        'uk-nav-navbar'
                    );
                }

                $('#panelPageSettingProperty').hide();
                $('[pageid=' + pageId + ']')
                    .closest('li.liListPage')
                    .remove();
                navMenuDeleteElem.remove();

                //reset list page on page setting
                $('ul#listPage').empty();
                RVwys.pageSetting.listPageNavigation();

                //remove datapage in jsonInternalPageStructure
                var getIndexInternalPage = jsonInternalPageStructure.findIndex(
                    function (val) {
                        return val.project_page_id == pageId;
                    }
                );

                if (getIndexInternalPage >= 0) {
                    jsonInternalPageStructure.splice(getIndexInternalPage, 1);
                }

                //remove data in jsonPageStructure
                var getIndexNormalPageForDelete = jsonPageStructure.findIndex(
                    function (val) {
                        return val.pageId == pageId;
                    }
                );

                if (getIndexNormalPageForDelete >= 0) {
                    jsonPageStructure.splice(getIndexNormalPageForDelete, 1);
                }

                //hide page setting dialog
                $('#panelPageSetting').hide();

                return true;
            },
            deleteNavCurrent: function (
                getPageIdMainSub,
                removeEmptyUl,
                checkMainSub
            ) {
                $('i[pageid=' + getPageIdMainSub + ']').removeAttr('ismainsub');
                RVwys.frameBody
                    .find('nav.uk-navbar')
                    .find('span[pageid=' + getPageIdMainSub + ']')
                    .find('i.uk-icon-caret-down')
                    .remove();

                //if main level1 li dont has child remove class uk-parent
                if (
                    RVwys.frameBody
                        .find('nav.uk-navbar')
                        .find('span[pageid=' + getPageIdMainSub + ']')
                        .closest('.uk-parent')
                        .hasClass('uk-parent') &&
                    checkMainSub == 'uk-nav-navbar'
                ) {
                    RVwys.frameBody
                        .find('nav.uk-navbar')
                        .find('span[pageid=' + getPageIdMainSub + ']')
                        .closest('.uk-parent')
                        .removeClass('uk-parent');
                }

                removeEmptyUl.remove();
            },
        };
    };

    //renamePage
    RVwys.pageSetting.renamePage = function () {
        return {
            addEvent: function () {
                //event dbclick to rename page
                jQuery('body').on('dblclick', '.editpagename', function () {
                    /*
					$('.editpagename').css('border', 'none');
					$(this).css({'border': 'solid red 1px', 'outline': 'none'}).attr('contenteditable', true).data('thisHtml',  $(this).html());

					var range = document.createRange();
					range.selectNodeContents($(this).get(0));
					var sel = window.getSelection();
					sel.removeAllRanges();
					sel.addRange(range);
					*/
                });

                //event on blur save page name
                jQuery('body').on('blur', '.editpagename', function () {
                    if ($(this).data('thisHtml') == $(this).html()) {
                    } else {
                        RVwys.pageSetting.renamePage.saveRenamePageAjax(
                            $(this).attr('pageid'),
                            $(this).html()
                        );
                    }
                    $(this).attr('contenteditable', false);
                    $(this).css('border', 'none');
                });

                //event open dialog rename page
                RVwys.pageSetting.buttonOpenDialogRenamePage.click(function () {
                    setTimeout(function () {
                        var pageName = $('#panelPageSettingProperty').data(
                            'pagename'
                        );
                        var fileName = $('#panelPageSettingProperty').data(
                            'page_filename'
                        );
                        console.log(
                            'OpenDialogRenamePage == pageName: ' +
                                pageName +
                                ' fileName: ' +
                                fileName
                        );

                        $('.txtRenamePage').eq(1).val(pageName);

                        if (fileName && fileName != 'undefined') {
                            $('.txtRenameFile')
                                .eq(1)
                                .val(
                                    decodeURIComponent(
                                        fileName.match(/.*(?=\.)/g)[0]
                                    )
                                );
                        }

                        //ถ้า ไม่มีชื่อ file name ให้ใช้ชื่อ page name
                        if ($('.txtRenameFile').eq(1).val().length === 0) {
                            $('.txtRenameFile')
                                .eq(1)
                                .val(pageName.replace(/\s/g, '-'));
                        }
                    }, 100);

                    RVwys.uikitDialog(
                        'Rename',
                        $('#panelRenamePage').html(),
                        'OK',
                        function () {
                            var getTxtRenamePage = $('.txtRenamePage')
                                .eq(1)
                                .val();
                            var getTxtRenameFile = $('.txtRenameFile')
                                .eq(1)
                                .val();
                            var isDuplicateRename = '0';

                            //check page name add space
                            getTxtRenamePage = getTxtRenamePage.trim();
                            getTxtRenameFile = getTxtRenameFile.trim();
                            var oldPage = $('#panelPageSettingProperty').data(
                                'pagename'
                            );
                            var oldFile = $('#panelPageSettingProperty').data(
                                'page_filename'
                            );

                            console.log(
                                'getTxtRenamePage = ' +
                                    getTxtRenamePage +
                                    ' length: ' +
                                    getTxtRenamePage.length
                            );
                            console.log(
                                'getTxtRenameFile = ' +
                                    getTxtRenameFile +
                                    ' length: ' +
                                    getTxtRenameFile.length
                            );
                            //console.log('oldPage = ' +  oldPage + ' length: ' + oldPage.length);
                            //console.log('oldFile = ' +  oldFile + ' length: ' + oldFile.length);

                            if (oldPage != getTxtRenamePage) {
                                //case: rename ที่ไม่ใช่ ค่าเดิมให้ validate Duplicate page in Allpage
                                var getAllPageName = RVwys.pageSetting.arrPagename.concat(
                                    RVwys.pageSetting.arrInternalPageName
                                );
                                //console.log(getAllPageName);
                                //console.log('==================');
                                //unset current pageName
                                var nameIndex = getAllPageName.indexOf(oldPage);
                                getAllPageName.splice(nameIndex, 1);
                                //console.log(getAllPageName);

                                var isDuplicateRename = getAllPageName.find(
                                    function (value, indexArr, thisArr) {
                                        return value == getTxtRenamePage;
                                    }
                                );
                            }

                            console.log(
                                '--typeof isDuplicateRename = ' +
                                    typeof isDuplicateRename
                            );
                            console.log(
                                '--isDuplicateRename = ' + isDuplicateRename
                            );

                            if (
                                getTxtRenamePage != '' &&
                                getTxtRenameFile != ''
                            ) {
                                $('.txtRenamePage')
                                    .eq(1)
                                    .nextAll('#warningPageRenameEmpty')
                                    .hide();

                                //check rename duplicate page
                                if (
                                    typeof isDuplicateRename == 'string' &&
                                    isDuplicateRename != '0'
                                ) {
                                    console.log(
                                        'case: 000 rename duplicate page ' +
                                            getTxtRenamePage
                                    );
                                    $('.txtRenamePage')
                                        .eq(1)
                                        .nextAll('#warningPageRenameDup')
                                        .show();
                                    RVwys.warningUiKitDialog = true;
                                } else if (
                                    getTxtRenamePage ===
                                        $('#panelPageSettingProperty').data(
                                            'pagename'
                                        ) ||
                                    getTxtRenameFile ===
                                        $('#panelPageSettingProperty')
                                            .data('page_filename')
                                            .match(/.*(?=\.)/g)[0]
                                ) {
                                    console.log(
                                        'case: 111 rename same page ' +
                                            getTxtRenamePage
                                    );
                                    RVwys.pageSetting.arrPagename[
                                        RVwys.pageSetting.arrPagename.indexOf(
                                            $('#panelPageSettingProperty').data(
                                                'pagename'
                                            )
                                        )
                                    ] = getTxtRenamePage;
                                    RVwys.pageSetting.renamePage.saveRenamePageAjax(
                                        $('#panelPageSettingProperty').data(
                                            'pageid'
                                        ),
                                        getTxtRenamePage,
                                        getTxtRenameFile
                                    );
                                    RVwys.warningUiKitDialog = false;

                                    //console.log('=== sucess 111 ===');
                                    //var getAllPageName = RVwys.pageSetting.arrPagename.concat(RVwys.pageSetting.arrInternalPageName);
                                    //console.log(getAllPageName);
                                } else {
                                    console.log(
                                        'case: 222 rename other page ' +
                                            getTxtRenamePage
                                    );
                                    RVwys.pageSetting.arrPagename[
                                        RVwys.pageSetting.arrPagename.indexOf(
                                            $('#panelPageSettingProperty').data(
                                                'pagename'
                                            )
                                        )
                                    ] = getTxtRenamePage;
                                    RVwys.pageSetting.renamePage.saveRenamePageAjax(
                                        $('#panelPageSettingProperty').data(
                                            'pageid'
                                        ),
                                        getTxtRenamePage,
                                        getTxtRenameFile
                                    );
                                    RVwys.warningUiKitDialog = false;

                                    //console.log('=== sucess 222 ===');
                                    //var getAllPageName = RVwys.pageSetting.arrPagename.concat(RVwys.pageSetting.arrInternalPageName);
                                    //console.log(getAllPageName);
                                }
                            } else {
                                //show warning empty page OR add space
                                $('.txtRenamePage')
                                    .eq(1)
                                    .nextAll('#warningPageRenameEmpty')
                                    .show();
                                $('.txtRenamePage')
                                    .eq(1)
                                    .nextAll('#warningPageRenameDup')
                                    .hide();
                                RVwys.warningUiKitDialog = true;
                            }
                        },
                        function () {
                            RVwys.warningUiKitDialog = false;
                        }
                    );

                    /*
					$('.pageSetting').not("#panelPageSettingProperty, #panelRenamePage").hide();
					var getPosition = $(this).offset();

					if($('#panelRenamePage').css('display') == 'none'){
						$('#panelRenamePage').css({left: getPosition.left + 15, top: getPosition.top + 15 }).show();
						$('#txtRenamePage').val($('#panelPageSettingProperty').data('pagename'));
					}else{
						$('#panelRenamePage').hide();
					}
					*/
                });
            },
            checkDupRenamePage: function (value, indexArr, thisArr) {
                console.log('checkDupRenamePage: 1 value: ' + value);
                console.log(
                    'checkDupRenamePage: 2 val: ' +
                        $('.txtRenamePage').eq(1).val()
                );
                return value == $('.txtRenamePage').eq(1).val();
            },
            saveRenamePageAjax: function (pageId, pageName, pageFileName) {
                console.log('saveRenamePageAjax()');
                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'PageContent',
                        rvsAct: 'renamePageContent',
                        project_page_id: pageId,
                        pageName: pageName,
                    }, // serializes the form's elements.
                    success: function (data) {},
                });

                var getUrlForSaveFileName = RVwys.pageSetting
                        .AjaxUrl()
                        .replace(
                            'action/sitebuilderAjaxExecute',
                            'extras_filename'
                        ),
                    aPageFileName =
                        'aPageStructureData[' + pageId + '][file_name]',
                    aPageHiddenFileName =
                        'aPageStructureData[' + pageId + '][hidden_file_name]',
                    formFileName = new FormData();

                //replace space , "_"
                pageFileName = pageFileName.replace(/\s/g, '_');

                formFileName.append('action', 'update');
                formFileName.append(aPageFileName, pageFileName);
                formFileName.append(aPageHiddenFileName, pageFileName);

                var getObjToSaveFileName = {
                    action: 'update',
                };

                getObjToSaveFileName[aPageFileName] = pageFileName;
                getObjToSaveFileName[aPageHiddenFileName] = pageFileName;

                console.log(getObjToSaveFileName);

                var request = new XMLHttpRequest();
                // POST to httpbin which returns the POST data as JSON
                request.open('POST', getUrlForSaveFileName, true);
                request.send(formFileName);

                //rename data page_name in jsonInternalPageStructure
                var getIndexInternalPage = jsonInternalPageStructure.findIndex(
                    function (val) {
                        return val.project_page_id == pageId;
                    }
                );

                if (getIndexInternalPage >= 0) {
                    jsonInternalPageStructure[
                        getIndexInternalPage
                    ].page_name = pageName;
                }
                var titlePageName = pageName.length > 10 ? pageName : '';
                var replaceHtml = `<span class="editPageWithPageName" pageid="${pageId}"
                pagename="${pageName}" title="${titlePageName}">${pageName}</span>`;

                //set option PageName
                $('#panelPageSettingProperty').data('pagename', pageName);
                $('i[pageid=' + pageId + ']')
                    .closest('li.liListPage')
                    .attr('data-pagename', pageName);
                $('div[pageid=' + pageId + ']').html(replaceHtml);
                $('i[pageid=' + pageId + ']').attr('pagename', pageName);

                //set option FileName
                $('#panelPageSettingProperty').data(
                    'page_filename',
                    pageFileName + '.html'
                );
                $('i[pageid=' + pageId + ']')
                    .closest('li.liListPage')
                    .attr('data-pagefilename', pageFileName + '.html');

                //change name on nav
                RVwys.frameBody
                    .find('span[pageid=' + pageId + ']')
                    .html(pageName);

                //change name on breadcrumb
                RVwys.frameBody
                    .find('#selected_pathway')
                    .find('[pageid=' + pageId + ']')
                    .html(pageName);

                //change attr file_name on nav
                RVwys.frameBody
                    .find('span[pageid=' + pageId + ']')
                    .attr('file_name', pageFileName + '.html');

                //update footer
                RVwys.frameBody
                    .find('#sitemapFooter')
                    .find('span[pageid=' + pageId + ']')
                    .html('| ' + pageName);
            },
        };
    };

    //setHomePage
    RVwys.pageSetting.setHomePage = function () {
        return {
            addEvent: function () {
                //event open confirm dialog set home page
                RVwys.pageSetting.buttonOpenDialogSetHomePage.click(
                    function () {
                        $('.pageSetting')
                            .not('#panelPageSettingProperty')
                            .hide();

                        RVwys.uikitDialog(
                            'Set homepage',
                            'Are you sure to make this your homepage?',
                            'OK',
                            function () {
                                RVwys.pageSetting.setHomePage.saveHomePageAjax(
                                    $('#panelPageSettingProperty').data(
                                        'pageid'
                                    )
                                );
                            }
                        );
                    }
                );
            },
            saveHomePageAjax: function (pageId) {
                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'PageContent',
                        rvsAct: 'setHomePage',
                        project_page_id: pageId,
                    }, // serializes the form's elements.
                    success: function (data) {
                        $('ul#listPage')
                            .find('.icon-home')
                            .remove()
                            .end()
                            .find('i[ishomepage]')
                            .removeAttr('ishomepage')
                            .end()
                            .find('i[pageid=' + pageId + ']')
                            .attr('ishomepage', 'true');
                        $('div[pageid=' + pageId + ']')
                            .closest('li.liListPage')
                            .prepend(
                                '<i class="uk-icon-small icon-home icon-control-home"></i>'
                            );
                        RVwys.frameBody
                            .find('span[is_homepage=1]')
                            .attr('is_homepage', '0')
                            .end()
                            .find('span[pageid=' + pageId + ']')
                            .attr('is_homepage', '1');
                    },
                });
            },
        };
    };

    RVwys.pageSetting.addLinkToMenu = function () {
        return {
            addEvent: function () {
                //event open dialog set link to other page
                RVwys.pageSetting.buttonOpenDialogSetLinkToOtherSitePage.click(
                    function () {
                        console.log(
                            'buttonOpenDialogSetLinkToOtherSitePage click'
                        );

                        RVwys.uikitDialog(
                            'Link to other page',
                            $('#panelLinkToOtherPage').html(),
                            'OK',
                            function () {
                                var validateLinkUrl = $('.txtLinkOtherPage')
                                    .eq(1)
                                    .val()
                                    .trim();
                                validateLinkUrl = validateLinkUrl.match(
                                    /(^http\:\/\/)|(^https\:\/\/)/gi
                                );
                                console.log(
                                    'validateLinkUrl : ',
                                    validateLinkUrl
                                );

                                if (
                                    $('.txtLinkOtherPage').eq(1).val() == '' ||
                                    validateLinkUrl
                                ) {
                                    RVwys.pageSetting.addLinkToMenu.saveLinkToMenuAjax(
                                        $('#panelPageSettingProperty').data(
                                            'pageid'
                                        ),
                                        $('.txtLinkOtherPage').eq(1).val()
                                    );
                                    $('.txtLinkOtherPage')
                                        .eq(1)
                                        .nextAll('#warningLinkNoHttp')
                                        .hide();
                                    $('.unSetLinkToOtherSitePage').show();
                                    RVwys.warningUiKitDialog = false;
                                } else {
                                    $('.txtLinkOtherPage')
                                        .eq(1)
                                        .nextAll('#warningLinkNoHttp')
                                        .show();
                                    RVwys.warningUiKitDialog = true;
                                }
                            },
                            function () {
                                RVwys.warningUiKitDialog = false;
                            }
                        );

                        /*
					$('.pageSetting').not("#panelPageSettingProperty, #panelLinkToOtherPage").hide();
					var getPosition = $(this).offset();

					if($('#panelLinkToOtherPage').css('display') == 'none'){
						$('#panelLinkToOtherPage').css({left: getPosition.left + 15, top: getPosition.top + 15 }).show();

					}else{
						$('#panelLinkToOtherPage').hide();
					}
					*/

                        var getLinkUrl = RVwys.frameBody
                                .find(
                                    'span[pageid=' +
                                        $('#panelPageSettingProperty').data(
                                            'pageid'
                                        ) +
                                        ']'
                                )
                                .parent()
                                .attr('title'),
                            getPageName = RVwys.frameBody
                                .find(
                                    'span[pageid=' +
                                        $('#panelPageSettingProperty').data(
                                            'pageid'
                                        ) +
                                        ']'
                                )
                                .html();

                        if (getLinkUrl) {
                            var getLinkUrlForCheck = getLinkUrl.split('/');
                            getLinkUrlForCheck =
                                getLinkUrlForCheck[
                                    getLinkUrlForCheck.length - 1
                                ];
                            getLinkUrlForCheck = getLinkUrlForCheck.replace(
                                '.html',
                                ''
                            );
                        }

                        if (
                            getLinkUrl != '' &&
                            getLinkUrl != 'undefined' &&
                            getLinkUrl != undefined &&
                            getLinkUrlForCheck != getPageName
                        ) {
                            console.log(
                                'type of getLinkUrl: ' +
                                    typeof getLinkUrl +
                                    ' getLinkUrl: ' +
                                    getLinkUrl
                            );
                            console.log('getLinkUrl: ' + getLinkUrl);
                            setTimeout(function () {
                                $('.txtLinkOtherPage').eq(1).val(getLinkUrl);
                            }, 100);
                            //$('#txtLinkOtherPage').val(getLinkUrl);
                        } else {
                            setTimeout(function () {
                                $('.txtLinkOtherPage').eq(1).val('http://');
                            }, 100);
                            //$('#txtLinkOtherPage').val("");
                        }
                    }
                );

                //event open dialog Un set link to other page
                RVwys.pageSetting.buttonOpenDialogUnSetLinkToOtherSitePage.click(
                    function () {
                        RVwys.uikitDialog(
                            'Unlink to other page',
                            $('#panelUnLinkToOtherPage').html(),
                            'OK',
                            function () {
                                RVwys.pageSetting.addLinkToMenu.saveLinkToMenuAjax(
                                    $('#panelPageSettingProperty').data(
                                        'pageid'
                                    ),
                                    'http://'
                                );
                                console.log('panelUnLinkToOtherPage ==> Ok');
                                //hide unset link
                                $('.unSetLinkToOtherSitePage').hide();

                                console.log('show option page normal');
                                //show option page normal กลับคืนมา
                                $('#panelPageSettingProperty')
                                    .find('#setHomePage')
                                    .show();
                                $('#panelPageSettingProperty')
                                    .find('#hideFromNavigation')
                                    .show();
                                $('#panelPageSettingProperty')
                                    .find('#seoPage')
                                    .show();
                                $('#panelPageSettingProperty')
                                    .find('#pageCss')
                                    .show();
                            }
                        );
                    }
                );
            },
            saveLinkToMenuAjax: function (pageId, linkUrl) {
                console.log('fn: saveLinkToMenuAjax');
                var setTarget,
                    pageType,
                    oldTarget,
                    oldPageType,
                    extLink,
                    linkId,
                    checkUrl,
                    regExp = new RegExp('(http://|https://)', 'g');
                checkUrl = linkUrl.replace(regExp, '');

                if (checkUrl) {
                    console.log('blank');
                    oldPageType = 'useTemplate';
                    oldTarget = '_self';
                    pageType = 'externalUrl';
                    setTarget = '_blank';
                    extLink = linkUrl;
                    linkId = '';
                    $('i.editPage[pageid=' + pageId + ']')
                        .removeClass('icon-edit')
                        .addClass('uk-icon-link');

                    console.log('hide option page normal');
                    //event set link hide option page normal
                    $('#panelPageSettingProperty').find('#setHomePage').hide();
                    $('#panelPageSettingProperty')
                        .find('#hideFromNavigation')
                        .hide();
                    $('#panelPageSettingProperty').find('#seoPage').hide();
                    $('#panelPageSettingProperty').find('#pageCss').hide();
                } else {
                    console.log('self');
                    oldPageType = 'externalUrl';
                    oldTarget = '_blank';
                    pageType = 'useTemplate';
                    setTarget = '_self';
                    extLink = '';
                    linkId = '0';
                    $('i.editPage[pageid=' + pageId + ']')
                        .removeClass('uk-icon-link')
                        .addClass('icon-edit');
                }

                RVwys.pageSetting.addLinkToMenu.updateAddLinkToPageOnNav(
                    pageId,
                    setTarget,
                    extLink
                );

                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'PageContent',
                        rvsAct: 'setLinkTarget',
                        projectPageId: pageId,
                        'frmEditPage[linkId]': linkId,
                        'frmEditPage[oldPageType]': oldPageType,
                        'frmEditPage[oldTarget]': oldTarget,
                        isInternal: '0',
                        'frmEditPage[pageType]': pageType,
                        'frmEditPage[external_url]': extLink,
                        'frmEditPage[target]': setTarget,
                    }, // serializes the form's elements.
                    success: function (data) {
                        console.log(data);
                        $('#panelLinkToOtherPage').hide();
                    },
                });
            },
            updateAddLinkToPageOnNav: function (pageId, getTarget, linkUrl) {
                if (getTarget == '_blank') {
                    RVwys.frameBody
                        .find('span[pageid=' + pageId + ']')
                        .parent()
                        .attr({ title: linkUrl, target: getTarget });
                } else {
                    RVwys.frameBody
                        .find('span[pageid=' + pageId + ']')
                        .parent()
                        .removeAttr('title')
                        .attr('target', getTarget);
                }
            },
        };
    };

    RVwys.pageSetting.setHide = function () {
        console.log('RVwys.pageSetting.setHide()');
        return {
            addEvent: function () {
                $('#setHide').click(function () {
                    $('.pageSetting').not('#panelPageSettingProperty').hide();
                    RVwys.uikitDialog(
                        'Set Draft',
                        $('#panelSetHidePage').html(),
                        'OK',
                        function () {
                            RVwys.pageSetting.setHide.saveSetHideAjax(
                                $('#panelPageSettingProperty').data('pageid'),
                                'updateSetHide'
                            );
                        }
                    );
                });

                $('#unsetHide').click(function () {
                    $('.pageSetting').not('#panelPageSettingProperty').hide();
                    RVwys.uikitDialog(
                        'Unset Draft',
                        $('#panelUnsetHidePage').html(),
                        'OK',
                        function () {
                            RVwys.pageSetting.setHide.saveSetHideAjax(
                                $('#panelPageSettingProperty').data('pageid'),
                                'updateUnSetHide'
                            );
                        }
                    );
                });
            },
            saveSetHideAjax: function (pageId, getAction) {
                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'PageContent',
                        rvsAct: getAction,
                        project_page_id: pageId,
                    }, // serializes the form's elements.
                    success: function (data) {
                        console.log(data);
                        if (getAction == 'updateSetHide') {
                            var isDraft = RVwys.frameBody
                                .find('#sitemapFooter')
                                .find('span[pageid=' + pageId + ']')
                                .attr('is_draft');
                            console.log(
                                '=saveSetHideAjax > case1==:' +
                                    getAction +
                                    ' is_draft=: ' +
                                    isDraft
                            );

                            $('i[pageid=' + pageId + ']').attr(
                                'issethide',
                                'true'
                            );

                            //set hide navigation
                            RVwys.frameBody
                                .find('span[pageid=' + pageId + ']')
                                .attr('is_draft', '1')
                                .closest('li')
                                .hide();
                            //set hide footer
                            RVwys.frameBody
                                .find('#sitemapFooter')
                                .find('span[pageid=' + pageId + ']')
                                .attr('is_draft', '1')
                                .hide();

                            $('li[data-id=' + pageId + ']').attr(
                                'data-sethide',
                                1
                            );
                            $('div.editpagename[pageid=' + pageId + ']').css(
                                'color',
                                '#ccc'
                            );
                            $(
                                'div.editpagename[pageid=' + pageId + '] > span'
                            ).prepend(
                                '<span pageid="' +
                                    pageId +
                                    '" class="textdraft" style="display:inline;"> (Draft) </span>'
                            );
                        } else {
                            var isDraft = RVwys.frameBody
                                .find('#sitemapFooter')
                                .find('span[pageid=' + pageId + ']')
                                .attr('is_draft');
                            console.log(
                                '=saveSetHideAjax > case2==:' +
                                    getAction +
                                    ' is_draft=: ' +
                                    isDraft
                            );

                            $('i[pageid=' + pageId + ']').removeAttr(
                                'issethide'
                            );
                            $('li[data-id=' + pageId + ']').attr(
                                'data-sethide',
                                0
                            );

                            //set show navigation
                            RVwys.frameBody
                                .find('span[pageid=' + pageId + ']')
                                .attr('is_draft', '0')
                                .closest('li')
                                .show();

                            //set show footer
                            RVwys.frameBody
                                .find('#sitemapFooter')
                                .find('span[pageid=' + pageId + ']')
                                .attr('is_draft', '0')
                                .show();

                            $('div.editpagename[pageid=' + pageId + ']').css(
                                'color',
                                '#414141'
                            );
                            $('div.editpagename[pageid=' + pageId + '] > span')
                                .find('.textdraft')
                                .remove();
                        }

                        console.log('==isDraft==' + isDraft);
                        console.log('==pageId==' + pageId);

                        $('#panelPageSettingProperty').hide();
                    },
                });
            },
            hideNavMenuIsDraft: function () {
                //console.log('hideNavMenuIsDraft');
                RVwys.frameBody.find('span[is_draft=1]').each(function () {
                    $(this).closest('li').hide();
                });
            },
        };
    };

    //Event Css Page
    RVwys.pageSetting.CssPage = function () {
        return {
            addEvent: function () {
                //open pageCss panal
                $('#pageCss').click(function () {
                    console.log('open pageCss');
                    RVwys.uikitDialog(
                        'Edit CSS',
                        $('#panelPageCss').html(),
                        'OK',
                        function () {
                            RVwys.pageSetting.CssPage.saveCssByPageAjax(
                                $('#panelPageSettingProperty').data('pageid'),
                                $('.txt_page_css').eq(1).val()
                            );
                        }
                    );

                    //get ค่ามาใส่ใน aear
                    var getPageCss = decodeURIComponent(
                        $('#panelPageSettingProperty')
                            .data('page_css')
                            .replace(/\+/g, ' ')
                    );
                    console.log('getPageCss:');

                    if (
                        getPageCss != '' &&
                        getPageCss != 'undefined' &&
                        getPageCss != 'null'
                    ) {
                        setTimeout(function () {
                            $('.txt_page_css').eq(1).val(getPageCss);
                        }, 100);
                    } else {
                        setTimeout(function () {
                            $('.txt_page_css').eq(1).val('');
                        }, 100);
                    }
                });

                //save title seo
                $('#buttonSaveTitlePage').click(function () {
                    RVwys.pageSetting.CssPage.saveCssByPageAjax(
                        $('#panelPageSettingProperty').data('pageid'),
                        $('#page_css').val()
                    );
                });
            },
            saveCssByPageAjax: function (pageId, pageCss) {
                var pageCssOnAttr = encodeURIComponent(pageCss);
                console.log('saveCssByPageAjax');
                RVwys.frameBody
                    .find('span[pageid=' + pageId + ']')
                    .attr('page_css', pageCssOnAttr);
                $('#panelPageSettingProperty').data('page_css', pageCssOnAttr);
                $('li.liListPage[data-id=' + pageId + ']').attr(
                    'data-pagecss',
                    pageCssOnAttr
                );

                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'Tag',
                        rvsAct: 'saveTagCssByPage',
                        project_page_id: pageId,
                        tagcssByPage: pageCss,
                        template_item_folder: templateFolder,
                    },
                    success: function (data) {
                        console.log('saveCssPageAjax success');
                        //console.log(data);
                        var project_id = data.project_id;

                        //build pageCss
                        //case current pageId to edit จะเป็น pageId เดียวกันถึงจะ buildCss
                        if (project_page_id == pageId) {
                            console.log(
                                'build pageCss:: Edit Css current page:' +
                                    project_page_id +
                                    ' to page: ' +
                                    pageId
                            );
                            RVwys.pageSetting.buildCssByPageId(
                                project_page_id,
                                pageId,
                                'Edit Css'
                            );
                        }
                    },
                });
            },
        }; //End return
    };

    RVwys.pageSetting.SEO = function () {
        return {
            addEvent: function () {
                //open SEO panal
                $('#seoPage').click(function () {
                    console.log('open seoPage');
                    RVwys.uikitDialog(
                        'SEO page',
                        $('#panelSEOPage').html(),
                        'OK',
                        function () {
                            RVwys.pageSetting.SEO.saveTitlePageAjax(
                                $('#panelPageSettingProperty').data('pageid'),
                                $('.txt_new_page_title').eq(1).val()
                            );
                            RVwys.pageSetting.SEO.saveMetaKeywordAjax(
                                $('#panelPageSettingProperty').data('pageid'),
                                $('.txt_meta_keyword').eq(1).val(),
                                $('.txt_meta_description').eq(1).val(),
                                $('.txt_other_embeded').eq(1).val()
                            );
                        }
                    );

                    var getPagetitle = $('#panelPageSettingProperty').data(
                        'page_title'
                    );
                    var getMetaKeyword = $('#panelPageSettingProperty').data(
                        'page_keyword'
                    );
                    var getMEtaDescription = $(
                        '#panelPageSettingProperty'
                    ).data('page_description');
                    var getOtherEmbed = decodeURIComponent(
                        $('#panelPageSettingProperty')
                            .data('page_otherembed')
                            .replace(/\+/g, ' ')
                    );

                    if (
                        getPagetitle != '' &&
                        getPagetitle != 'undefined' &&
                        getPagetitle != 'null'
                    ) {
                        setTimeout(function () {
                            $('.txt_new_page_title').eq(1).val(getPagetitle);
                        }, 100);
                        //$('#txtLinkOtherPage').val(getLinkUrl);
                    } else {
                        setTimeout(function () {
                            $('.txt_new_page_title').eq(1).val('');
                        }, 100);
                        //$('#txtLinkOtherPage').val("");
                    }

                    if (
                        getMetaKeyword != '' &&
                        getMetaKeyword != 'undefined' &&
                        getMetaKeyword != 'null'
                    ) {
                        setTimeout(function () {
                            $('.txt_meta_keyword').eq(1).val(getMetaKeyword);
                        }, 100);
                    } else {
                        setTimeout(function () {
                            $('.txt_meta_keyword').eq(1).val('');
                        }, 100);
                    }

                    if (
                        getMEtaDescription != '' &&
                        getMEtaDescription != 'undefined' &&
                        getMEtaDescription != 'null'
                    ) {
                        setTimeout(function () {
                            $('.txt_meta_description')
                                .eq(1)
                                .val(getMEtaDescription);
                        }, 100);
                    } else {
                        setTimeout(function () {
                            $('.txt_meta_description').eq(1).val('');
                        }, 100);
                    }

                    if (
                        getOtherEmbed != '' &&
                        getOtherEmbed != 'undefined' &&
                        getOtherEmbed != 'null'
                    ) {
                        setTimeout(function () {
                            $('.txt_other_embeded').eq(1).val(getOtherEmbed);
                        }, 100);
                    } else {
                        setTimeout(function () {
                            $('.txt_other_embeded').eq(1).val('');
                        }, 100);
                    }

                    //maximun length
                    $('.txt_new_page_title').eq(1).attr('maxlength', '255');
                    $('.txt_meta_keyword').eq(1).attr('maxlength', '155');
                    $('.txt_meta_description').eq(1).attr('maxlength', '155');

                    /*
					$('.pageSetting').not("#panelPageSettingProperty, #panelSEOPage").hide();
					var getPosition = $(this).offset();

					if($('#panelSEOPage').css('display') == 'none'){
						$('#panelSEOPage').css({left: getPosition.left + 15, top: getPosition.top + 15 }).show();
						//$('#new_page_title').val($('#panelPageSettingProperty').data('pagename'));
					}else{
						$('#panelSEOPage').hide();
					}
					*/
                });

                //save title seo
                $('#buttonSaveTitlePage').click(function () {
                    RVwys.pageSetting.SEO.saveTitlePageAjax(
                        $('#panelPageSettingProperty').data('pageid'),
                        $('#new_page_title').val()
                    );
                });

                //save meta keyword
                $('#buttonSaveMetaKey').click(function () {
                    RVwys.pageSetting.SEO.saveMetaKeywordAjax(
                        $('#panelPageSettingProperty').data('pageid'),
                        $('#meta_keyword').val(),
                        $('#meta_description').val()
                    );
                });

                //event maximum length
                jQuery('body').on('keyup', '.txt_new_page_title', function (e) {
                    if (
                        $(this).val().length == '255' &&
                        $(this)
                            .next('#warningMaximunPageTitle')
                            .prop('tagName') != 'SPAN'
                    ) {
                        $(this).next('#warningMaximunPageTitle').show();
                    } else if ($(this).val().length < '255') {
                        $(this).next('#warningMaximunPageTitle').hide();
                    }
                });

                jQuery('body').on('keyup', '.txt_meta_keyword', function (e) {
                    if (
                        $(this).val().length == '155' &&
                        $(this)
                            .next('#warningMaximunMetaKeyword')
                            .prop('tagName') != 'SPAN'
                    ) {
                        $(this).next('#warningMaximunMetaKeyword').show();
                    } else if ($(this).val().length < '156') {
                        $(this).next('#warningMaximunMetaKeyword').hide();
                    }
                });

                jQuery('body').on(
                    'keyup',
                    '.txt_meta_description',
                    function (e) {
                        if (
                            $(this).val().length == '155' &&
                            $(this)
                                .next('#warningMaximunMetaTag')
                                .prop('tagName') != 'SPAN'
                        ) {
                            $(this).next('#warningMaximunMetaTag').show();
                        } else if ($(this).val().length < '156') {
                            $(this).next('#warningMaximunMetaTag').hide();
                        }
                    }
                );
            },
            saveTitlePageAjax: function (pageId, titlePage) {
                RVwys.frameBody
                    .find('span[pageid=' + pageId + ']')
                    .attr('page_title', titlePage);
                $('#panelPageSettingProperty').data('page_title', titlePage);
                $('li.liListPage[data-id=' + pageId + ']').attr(
                    'data-pagetitle',
                    titlePage
                );
                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'Extras_PageTitle',
                        rvsAct: 'update',
                        project_page_id: pageId,
                        new_page_title: titlePage,
                    },
                    success: function (data) {
                        console.log('saveTitlePageAjax success');
                        console.log(data);
                    },
                });
            },
            saveMetaKeywordAjax: function (
                pageId,
                metaKeyword,
                metaDescription,
                otherEmbeded
            ) {
                var otherEmbededOnAttr = encodeURIComponent(otherEmbeded);

                RVwys.frameBody.find('span[pageid=' + pageId + ']').attr({
                    meta_keyword: metaKeyword,
                    meta_description: metaDescription,
                    other_embed: otherEmbededOnAttr,
                });
                $('#panelPageSettingProperty').data({
                    page_keyword: metaKeyword,
                    page_description: metaDescription,
                    page_otherembed: otherEmbededOnAttr,
                });
                $('li.liListPage[data-id=' + pageId + ']').attr({
                    'data-pagekeyword': metaKeyword,
                    'data-pagedescription': metaDescription,
                    'data-otherembed': otherEmbededOnAttr,
                });

                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'extras_metatag',
                        rvsAct: 'update',
                        project_page_id: pageId,
                        meta_keyword: metaKeyword,
                        meta_description: metaDescription,
                        other_embeded: otherEmbeded,
                    },
                    success: function (data) {
                        console.log('saveMetaKeywordAjax success');
                        console.log(data);
                    },
                });
            },
            saveOtherEmbeded: function (pageId, otherEmbeded) {
                //RVwys.frameBody.find('span[pageid='+pageId+']').attr("page_title", titlePage);
                //$('#panelPageSettingProperty').data('page_title', titlePage);
                //$('li.liListPage[data-id='+pageId+']').attr('data-pagetitle', titlePage);
                console.log('saveOtherEmbeded');
                console.log(otherEmbeded);
                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'extras_metatag',
                        rvsAct: 'update',
                        project_page_id: pageId,
                        other_embeded: otherEmbeded,
                    },
                    success: function (data) {
                        console.log('saveOtherEmbeded success');
                        console.log(data);
                    },
                });
            },
        };
    };

    RVwys.pageSetting.hideFromNavigation = function () {
        return {
            addEvent: function () {
                //open SEO panal
                $('#hideFromNavigation').click(function () {
                    console.log('click:: hideFromNavigation:');

                    $('.pageSetting').not('#panelPageSettingProperty').hide();
                    RVwys.uikitDialog(
                        'Internal Page',
                        $('#panelHideFromNav').html(),
                        'OK',
                        function () {
                            var pageId = $('#panelPageSettingProperty').data(
                                'pageid'
                            );
                            var pageName = $('#panelPageSettingProperty').data(
                                'pagename'
                            );
                            var pageFileName = $('i[pageid=' + pageId + ']')
                                .closest('li.liListPage')
                                .attr('data-pagefilename');

                            console.log(
                                'pageId: ' +
                                    pageId +
                                    ' pageName: ' +
                                    pageName +
                                    ' pageFileName: ' +
                                    pageFileName
                            );
                            RVwys.pageSetting.hideFromNavigation.saveHideFromNavigationAjax(
                                pageId,
                                pageName,
                                pageFileName,
                                $('#panelPageSettingProperty')
                            );
                        }
                    );
                });

                //save title seo
                $('#buttonSaveHideFromNavigation').click(function () {
                    console.log('click:: SaveHideFromNavigatio:');

                    UIkit.modal.confirm(
                        'Are you sure? set internal page',
                        function () {
                            var pageId = $('#panelPageSettingProperty').data(
                                'pageid'
                            );
                            var pageName = $('#panelPageSettingProperty').data(
                                'pagename'
                            );
                            var pageFileName = $('i[pageid=' + pageId + ']')
                                .closest('li.liListPage')
                                .attr('data-pagefilename');

                            console.log(
                                'pageId: ' +
                                    pageId +
                                    ' pageName: ' +
                                    pageName +
                                    ' pageFileName: ' +
                                    pageFileName
                            );
                            RVwys.pageSetting.hideFromNavigation.saveHideFromNavigationAjax(
                                pageId,
                                pageName,
                                pageFileName,
                                $('#panelPageSettingProperty')
                            );
                        }
                    );
                });
            },
            saveHideFromNavigationAjax: function (
                pageId,
                pageName,
                pageFileName,
                getData
            ) {
                console.log(
                    'saveHideFromNavigationAjax() -> pageName: ' + pageName
                );

                var watingLoadPage = UIkit.modal.blockUI(
                    "<div class='uk-modal-spinner'></div>"
                );
                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'movepagecontent',
                        rvsAct: 'MoveToInternalPage',
                        project_page_id: pageId,
                    },
                    success: function (data) {
                        $('#panelHideFromNavigation').hide();
                        $('#panelPageSettingProperty').hide();
                        $('i[pageid=' + pageId + ']')
                            .closest('li.liListPage')
                            .wrap('<div></div>');
                        var getListPageHtml = $('i[pageid=' + pageId + ']')
                            .closest('li.liListPage')
                            .parent()
                            .html();

                        $('i[pageid=' + pageId + ']')
                            .first()
                            .closest('li.liListPage')
                            .parent()
                            .remove();
                        RVwys.frameBody
                            .find('span[pageid=' + pageId + ']')
                            .closest('li')
                            .remove();

                        //hide waiting
                        watingLoadPage.hide();

                        //add internal page name in array
                        RVwys.pageSetting.arrInternalPageName.push(pageName);

                        console.log(getData.data('page_title'));
                        pageFileName = pageFileName.match(/.*(?=\.)/g)[0];
                        //push to arr list internal page getData
                        jsonInternalPageStructure.push({
                            project_page_id: pageId,
                            page_name: pageName,
                            custom_page_name: pageFileName,
                            set_draft: 0,
                            page_title: getData.data('page_title'),
                            meta_keyword: getData.data('page_keyword'),
                            meta_description: getData.data('page_description'),
                        });

                        //list page navigation after hide from navigation
                        if (typeof jsonInternalPageStructure != 'undefined') {
                            RVwys.pageSetting.listInternalPageSetting(
                                jsonInternalPageStructure
                            );
                        }

                        //list page navigation after HideFromNavigation
                        $('ul#listPage').empty();
                        RVwys.pageSetting.listPageNavigation();
                    },
                });
            },
        };
    };

    RVwys.pageSetting.moveToNavigation = function () {
        return {
            addEvent: function () {
                //open SEO panal
                $('#movetoNavigation').click(function () {
                    console.log('click: movetoNavigation::');

                    $('.pageSetting').not('#panelPageSettingProperty').hide();
                    RVwys.uikitDialog(
                        'Move To Navigation',
                        $('#panelMoveToNav').html(),
                        'OK',
                        function () {
                            var pageId = $('#panelPageSettingProperty').data(
                                'pageid'
                            );
                            var pageName = $('#panelPageSettingProperty').data(
                                'pagename'
                            );
                            var pageFileName = $('i[pageid=' + pageId + ']')
                                .closest('li.liListPage')
                                .attr('data-pagefilename');

                            console.log(
                                'pageId: ' +
                                    pageId +
                                    ' pageName: ' +
                                    pageName +
                                    ' pageFileName: ' +
                                    pageFileName
                            );

                            RVwys.pageSetting.moveToNavigation.saveMoveToNavigationAjax(
                                pageId,
                                pageName,
                                pageFileName
                            );
                        }
                    );
                });
            },
            saveMoveToNavigationAjax: function (
                pageId,
                pageName,
                pageFileName
            ) {
                console.log(
                    'saveMoveToNavigationAjax pageName: ' +
                        pageName +
                        ' pageFileName: ' +
                        pageFileName
                );
                var watingLoadPage = UIkit.modal.blockUI(
                    "<div class='uk-modal-spinner'></div>"
                );
                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'movepagecontent',
                        rvsAct: 'MoveToMainPage',
                        project_page_id: pageId,
                    },
                    success: function (data) {
                        $('#panelHideFromNavigation').hide();
                        $('#panelPageSettingProperty').hide();
                        $('i[pageid=' + pageId + ']')
                            .closest('li.liListPage')
                            .wrap('<div></div>');
                        var getListPageHtml = $('i[pageid=' + pageId + ']')
                                .closest('li.liListPage')
                                .parent()
                                .html(),
                            pageTarget = $('i[pageid=' + pageId + ']')
                                .closest('li.liListPage')
                                .attr('data-pagetarget')
                                ? $('i[pageid=' + pageId + ']')
                                      .closest('li.liListPage')
                                      .attr('data-pagetarget')
                                : '',
                            pageLink = $('i[pageid=' + pageId + ']')
                                .closest('li.liListPage')
                                .attr('data-title')
                                ? 'title="' +
                                  $('i[pageid=' + pageId + ']')
                                      .closest('li.liListPage')
                                      .attr('data-title') +
                                  '"'
                                : '',
                            pageDraft = $('i[pageid=' + pageId + ']')
                                .closest('li.liListPage')
                                .attr('data-sethide'),
                            pageTitle =
                                $('i[pageid=' + pageId + ']')
                                    .closest('li.liListPage')
                                    .attr('data-pagetitle') != 'null'
                                    ? $('i[pageid=' + pageId + ']')
                                          .closest('li.liListPage')
                                          .attr('data-pagetitle')
                                    : '',
                            pageKeyword =
                                $('i[pageid=' + pageId + ']')
                                    .closest('li.liListPage')
                                    .attr('data-pagekeyword') != 'null'
                                    ? $('i[pageid=' + pageId + ']')
                                          .closest('li.liListPage')
                                          .attr('data-pagekeyword')
                                    : '',
                            pageDescription =
                                $('i[pageid=' + pageId + ']')
                                    .closest('li.liListPage')
                                    .attr('data-pagedescription') != 'null'
                                    ? $('i[pageid=' + pageId + ']')
                                          .closest('li.liListPage')
                                          .attr('data-pagedescription')
                                    : '',
                            pageName = $('i[pageid=' + pageId + ']')
                                .closest('li.liListPage')
                                .attr('data-pagename'),
                            getHtmlPageToWys =
                                '<li>' +
                                '<a href="javascript:void(0)" target="' +
                                pageTarget +
                                '" ' +
                                pageLink +
                                ' >' +
                                '<span pageid="' +
                                pageId +
                                '" file_name="' +
                                pageFileName +
                                '" is_homepage="0" is_draft="' +
                                pageDraft +
                                '" page_title="' +
                                pageTitle +
                                '" meta_keyword="' +
                                pageKeyword +
                                '" meta_description="' +
                                pageDescription +
                                '">' +
                                pageName +
                                '</span></a>' +
                                '</li>';

                        //add getListPageHtml
                        RVwys.pageSetting.ulListPageElem.append(
                            getListPageHtml
                        );
                        RVwys.pageSetting.ulListPageElem
                            .find('.confListPage')
                            .removeClass('internalPage');

                        //add nav in wys
                        RVwys.frameBody
                            .find('ul.uk-navbar-nav')
                            .append(getHtmlPageToWys);

                        //RVwys.pageSetting.ulLisInternaltPageElem.find('i[pageid='+pageId+']').closest('li.liListPage').parent().remove();

                        //hide waiting
                        watingLoadPage.hide();

                        //remove internal page name in array
                        RVwys.pageSetting.arrInternalPageName.splice(
                            RVwys.pageSetting.arrInternalPageName.indexOf(
                                pageName
                            ),
                            1
                        );

                        //remove datapage in jsonInternalPageStructure
                        var getIndexInternalPage = jsonInternalPageStructure.findIndex(
                            function (val) {
                                return val.project_page_id == pageId;
                            }
                        );

                        if (getIndexInternalPage >= 0) {
                            jsonInternalPageStructure.splice(
                                getIndexInternalPage,
                                1
                            );
                        }

                        //list page navigation after move to navigation
                        RVwys.pageSetting.listInternalPageSetting(
                            jsonInternalPageStructure
                        );

                        //list page navigation after MoveToNavigation
                        $('ul#listPage').empty();
                        RVwys.pageSetting.listPageNavigation();
                    },
                });
            },
        };
    };

    RVwys.pageSetting.duplicatePage = function () {
        return {
            addEvent: function () {
                //open duplicate panal
                $('#duplicatePage').click(function () {
                    RVwys.uikitDialog(
                        'Duplicate Page',
                        $('#panelDubplicatePage').html(),
                        'OK',
                        function () {
                            var pageId = $('#panelPageSettingProperty').data(
                                'pageid'
                            );
                            console.log('pageId: ' + pageId);

                            RVwys.pageSetting.duplicatePage.saveDuplicatePage(
                                pageId
                            );
                        }
                    );
                });
            },
            saveDuplicatePage: function (pageId) {
                console.log('saveDuplicatePage()');

                $.ajax({
                    type: 'POST',
                    url: RVwys.pageSetting.AjaxUrl(),
                    data: {
                        rvsMgr: 'PageContent',
                        rvsAct: 'clonePage',
                        project_page_id: pageId,
                    },
                    success: function (data) {
                        //console.log(data);
                        console.log(
                            'success new_custom_page_name: ' +
                                data.new_custom_page_name
                        );

                        //push to arr list internal page
                        if ($('#panelPageSettingProperty').data('pagename')) {
                            //jsonInternalPageStructure.push({'project_page_id': data.new_page_id, 'page_name': data.new_page_name, 'set_draft': 0});
                        }

                        $('#panelPageSettingProperty').hide();

                        var newPageFileName =
                            data.new_custom_page_name + '.html';
                        var navDuplicate = RVwys.frameBody.find(
                            'span[pageid=' + pageId + ']'
                        );
                        var navInsertHtml =
                            '<li>' +
                            '<a href="javascript:void(0)" target="_self">' +
                            '<span pageid="' +
                            data.new_page_id +
                            '" file_name="' +
                            newPageFileName +
                            '" is_homepage="0" is_draft="' +
                            navDuplicate.attr('is_draft') +
                            '">' +
                            data.new_page_name +
                            '</span>' +
                            '</a>' +
                            '</li>';
                        //add new item is not class="breadcrumb"
                        RVwys.frameBody
                            .find('span[pageid=' + pageId + ']')
                            .not('.breadcrumb')
                            .closest('li')
                            .after(navInsertHtml);

                        //clear list page in page setting
                        RVwys.pageSetting.ulListPageElem.html('');

                        //list page navigation after dubplicate page
                        RVwys.pageSetting.listPageNavigation();

                        //clear list internal page in page setting
                        RVwys.pageSetting.ulLisInternaltPageElem.empty();

                        //list page navigation after dubplicate page
                        RVwys.pageSetting.listInternalPageSetting(
                            jsonInternalPageStructure
                        );
                    },
                });
            },
        };
    };

    RVwys.BuildIframePageProperties = function (callBacks = null) {
        var overlayLoading = $(
            '<div class="overlayLoading overlaypanel">' +
                '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                '</div>'
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });

        if (!$('#Modal-Siteproperties').get(0)) {
            $('body').append(overlayLoading);

            var path = parent.wex.url.baseUrl + '/admin/siteproperty';
            var editorfull = $(
                '<iframe  id="Modal-Siteproperties" name="Modal-Siteproperties" src="' +
                    path +
                    '" width="100%" height="500"></iframe>'
            ).on('load', function (param) {
                window.SiteConfigIframe = $('#Modal-Siteproperties').get(
                    0
                ).contentWindow;
                $('.overlayLoading').remove();
                RVwys.RunIframePageProperties();
            });

            $('#ModalSiteproperties').append(editorfull);
        } else {
            RVwys.RunIframePageProperties();
        }
        if (callBacks) {
            callBacks();
        }
    };

    RVwys.RunIframePageProperties = function () {
        $('.rvsb-design-property ').hide();
        $('.wys-pageproperty').show();
        $('.bar-right,.bar-category,.bar-rightemail').addClass(
            'bar-category-hidden'
        );
        $('#panelPageSettingProperty,#panelPostSettingProperty').hide();
    };

    function switchStepBarActive() {
        //  parent.content_Wys('wys-content');
        var url = window.urlHref;
        if (url.match(/design/)) {
            parent.$('#showdesign').trigger('click');
        }
    }

    $(document).bind('designReady', function (e) {
        $(document).click(function () {
            //	    	ซ่อน .rvsb-design-property Page Option
            parent.$('.rvsb-design-property').hide();
        });
    });
})(jQuery);

(function (window) {
    window.htmlentities = {
        /**
         * Converts a string to its html characters completely.
         *
         * @param {String} str String with unescaped HTML characters
         **/
        encode: function (str) {
            var buf = [];

            for (var i = str.length - 1; i >= 0; i--) {
                buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
            }

            return buf.join('');
        },
        /**
         * Converts an html characterSet into its original character.
         *
         * @param {String} str htmlSet entities
         **/
        decode: function (str) {
            return str.replace(/&#(\d+);/g, function (match, dec) {
                return String.fromCharCode(dec);
            });
        },
    };
})(window);
